var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _path19, _path20, _g4, _path21, _path22, _path23, _path24, _path25, _path26, _g5, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVotingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 184,
    viewBox: "0 0 243 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 243,
    height: 176
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.305 4.18164H5.69913C2.55374 4.18164 0.00390625 6.73464 0.00390625 9.88393V174.11C0.00390625 177.259 2.55374 179.812 5.69913 179.812H237.305C240.45 179.812 243 177.259 243 174.11V9.88393C243 6.73464 240.45 4.18164 237.305 4.18164Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_124377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.231 91.2861C200.343 89.047 199.39 85.8537 199.128 84.9565C199.436 84.4395 199.618 84.0669 199.618 84.0669L199.538 84.1126C199.956 83.5157 200.282 83.0177 200.502 82.6718C200.609 82.5007 200.692 82.3639 200.761 82.2574C200.818 82.1624 200.844 82.1092 200.84 82.1054C203.532 77.9161 206.817 71.6588 206.779 67.3022C206.722 60.5583 204.144 60.3834 204.144 60.3834C204.128 60.3834 204.109 60.3834 204.09 60.3834L203.267 60.0755C202.872 57.5399 201.307 47.4354 200.859 44.3182C200.791 43.843 200.719 43.364 200.635 42.885C200.651 42.9078 200.662 42.923 200.666 42.923C200.666 42.923 200.654 42.885 200.628 42.8242C199.728 37.5324 197.86 32.3091 190.365 32.8451C190.365 32.8451 184.188 33.2633 182.361 37.7301C181.374 40.1479 180.273 49.2221 180.03 56.6997C180.019 57.0077 180.011 57.3118 180.003 57.6083C179.988 57.8402 179.962 58.0721 179.939 58.3078L178.204 58.5663C177.384 58.3914 169.422 72.1111 169.069 73.3998C168.716 74.6886 167.079 78.0909 167.079 80.4935C167.079 82.5045 168.959 83.6906 169.574 84.0251C169.691 84.0898 169.771 84.1278 169.771 84.1278L175.155 85.2416C175.28 85.2682 175.406 85.2948 175.531 85.3215C175.451 86.2832 175.39 86.8839 175.39 86.8839L174.191 93.6734C174.191 93.6734 174.179 93.6734 174.172 93.6734H174.134L174.115 93.7C173.655 94.3957 173.116 95.213 172.539 96.0874L172.482 96.171L172.581 96.19C172.626 96.2014 172.679 96.209 172.729 96.2204C173.063 96.2889 173.386 96.3535 173.705 96.4181L171.745 107.511L174.02 107.606C174.24 111.119 175.208 115.285 176.803 119.486C181.64 132.24 184.343 142.439 184.529 145.184C184.715 147.933 185.008 150.772 187.552 159.47C189.408 165.823 190.783 169.617 190.783 169.617V170.054C190.783 170.054 190.133 170.324 189.218 170.738C188.793 170.928 188.315 171.152 187.817 171.396C187.787 171.388 187.764 171.392 187.76 171.403C187.76 171.407 187.76 171.418 187.76 171.426C186.211 172.179 184.499 173.11 183.736 173.863C183.55 173.985 183.273 174.216 183.326 174.528L195.806 174.346C195.794 174.422 195.783 174.505 195.772 174.578C195.688 175.144 195.65 175.494 195.677 175.501C195.677 175.509 195.696 175.513 195.722 175.513L195.422 177.178C195.331 177.22 195.282 177.258 195.293 177.277C195.301 177.292 195.339 177.296 195.403 177.288L195.001 179.516C194.914 180.025 195.202 180.546 195.711 180.687C195.775 180.706 195.84 180.706 195.905 180.713L195.897 180.721C195.92 180.721 195.946 180.721 195.969 180.721C195.992 180.721 196.015 180.721 196.037 180.721C196.326 180.717 196.607 180.599 196.797 180.382C200.571 176.11 202.173 174.049 202.762 173.122C202.784 173.087 202.807 173.053 202.826 173.023C202.936 172.852 203.039 172.707 203.081 172.529C203.099 172.468 203.111 172.414 203.107 172.376V172.338C203.103 172.278 203.099 172.209 203.084 172.133L203.046 171.723L203.039 171.734L202.906 170.499C202.864 170.111 202.488 169.183 202.488 169.1L202.12 167.826L202.317 167.75C202.317 167.75 200.575 152.772 198.543 148.799C197.082 145.941 194.686 144.58 195.802 140.854C196.918 137.125 202.109 118.581 203.627 111.24C203.908 109.883 204.056 108.568 204.079 107.313L205.993 107.173C205.993 107.173 205.211 101.257 201.247 91.2822L201.231 91.2861ZM195.684 175.479C195.707 175.421 195.745 175.269 195.798 175.045L195.726 175.452C195.726 175.452 195.696 175.471 195.688 175.479H195.684Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.694 99.5886C178.439 98.1364 178.154 96.6234 177.854 95.061C177.722 94.2551 177.581 93.4643 177.448 92.6926C177.042 90.4383 176.636 88.3399 176.241 86.4315C176.085 85.6788 175.933 84.9603 175.781 84.2647C175.664 83.6564 175.546 83.052 175.432 82.4627C175.292 81.6796 175.124 80.9117 174.904 80.1818C174.471 78.7182 173.875 77.3763 173.108 76.2472C172.725 75.6846 172.3 75.1752 171.829 74.7494C171.514 74.5631 171.244 74.4871 170.959 74.3693C170.678 74.2628 170.401 74.1602 170.132 74.0613C167.975 73.2782 166.217 72.6814 164.998 72.2746C164.402 72.0769 163.931 71.9249 163.594 71.8146C163.442 71.769 163.32 71.731 163.225 71.7006C163.142 71.6778 163.1 71.6664 163.096 71.6702L161.524 69.9101C164.061 69.5413 166.43 68.1195 168.647 66.7358C169.596 66.1466 170.542 65.5535 171.491 64.9643H171.495C171.791 64.778 172.098 64.5803 172.273 64.2762C172.281 64.2648 172.281 64.2534 172.288 64.242C172.322 64.1812 172.345 64.1165 172.364 64.0519C172.379 64.0101 172.387 63.9645 172.395 63.9189C172.398 63.8846 172.406 63.8542 172.406 63.82C172.444 63.3981 172.258 62.9723 171.962 62.6073C171.825 62.4325 171.673 62.2728 171.51 62.136C171.328 61.9839 171.138 61.8356 170.948 61.6874C170.815 61.5809 170.477 61.3034 170.265 61.0715C170.234 61.0373 170.208 61.0031 170.177 60.9689C170.158 60.9423 170.135 60.9157 170.12 60.8928C169.995 60.6876 169.885 60.5051 169.817 60.3074C169.809 60.2808 169.801 60.2504 169.794 60.2238C169.779 60.1706 169.767 60.1135 169.76 60.0565C169.76 60.0565 169.76 60.0565 169.76 60.0527C169.733 59.7486 169.722 59.5889 169.763 59.2202C169.805 58.8476 169.953 58.2736 169.93 57.9543C169.93 57.9543 169.93 57.9543 169.93 57.9505C169.942 57.7604 169.934 57.5703 169.904 57.3916C169.904 57.3764 169.9 57.3574 169.896 57.3422C169.923 57.422 169.946 57.5019 169.961 57.5779C170.086 58.1976 169.949 58.726 169.877 59.0757C169.794 59.4293 169.744 59.6269 169.763 59.6307C169.779 59.6345 169.855 59.4483 169.965 59.0985C170.063 58.7526 170.234 58.2204 170.12 57.5475C170.063 57.2168 169.919 56.8518 169.631 56.5591C169.334 56.2664 168.917 56.1219 168.514 55.9889C168.112 55.8558 167.679 55.7076 167.421 55.3616C167.155 55.0157 167.109 54.5329 167.109 54.0463C167.109 53.5597 167.151 53.0617 167.049 52.5789C166.954 52.1037 166.756 51.6703 166.513 51.3016C166.012 50.5679 165.34 50.0965 164.748 49.8114C164.148 49.5301 163.624 49.4084 163.259 49.359C162.922 49.3134 162.732 49.3134 162.705 49.321C162.698 49.321 162.69 49.321 162.686 49.3172C162.663 49.3058 162.595 49.2906 162.485 49.2602C162.2 49.1803 161.919 49.0929 161.642 48.9941C161.262 48.8496 160.803 48.6367 160.351 48.2718C160.047 48.0209 159.774 47.6863 159.527 47.2796C159.273 46.8728 158.942 46.4622 158.54 46.0973C157.739 45.3598 156.623 44.8048 155.385 44.5919C154.143 44.3752 152.925 44.5539 151.903 44.9036C150.886 45.2648 150.012 45.7399 149.42 46.3254C148.828 46.907 148.551 47.5419 148.437 47.9829C148.38 48.2033 148.357 48.382 148.349 48.5037C148.342 48.6253 148.349 48.6861 148.357 48.6861C148.3 49.2906 148.368 49.914 148.197 50.4957C148.182 50.5413 148.163 50.5869 148.148 50.6325C148.133 50.6743 148.118 50.72 148.099 50.7618C148.08 50.8112 148.053 50.8568 148.03 50.9024C148.011 50.9442 147.989 50.9861 147.966 51.0279C147.958 51.0431 147.951 51.0545 147.943 51.0697C147.757 51.2256 147.522 51.3814 147.252 51.5639C146.929 51.7844 146.542 52.0467 146.246 52.4649C145.954 52.8754 145.741 53.4152 145.726 54.0159C145.707 54.6203 145.916 55.2286 146.06 55.8596C146.117 56.0953 146.159 56.3386 146.17 56.5857C146.17 56.6655 146.174 56.7492 146.17 56.829C146.155 57.1597 146.079 57.4981 145.889 57.7756C145.699 58.0531 145.395 58.2356 145.054 58.3306C144.712 58.4257 144.34 58.4447 143.964 58.4751C143.588 58.5055 143.201 58.5435 142.844 58.669C142.487 58.7906 142.153 58.9769 141.872 59.2164C141.306 59.6916 140.984 60.3948 140.961 61.0715C140.961 61.0715 140.961 61.0715 140.961 61.0753C140.927 61.7748 141.287 62.3488 141.47 62.881C141.564 63.1472 141.621 63.4171 141.614 63.6756C141.602 63.9341 141.519 64.1698 141.359 64.3446C141.048 64.6982 140.562 64.8046 140.209 64.6944C139.844 64.5841 139.632 64.2914 139.533 64.0443C139.461 63.8504 139.442 63.687 139.446 63.5577C139.45 63.3752 139.499 63.2612 139.503 63.2346C139.503 63.2232 139.503 63.2194 139.503 63.2194C139.503 63.2194 139.457 63.284 139.419 63.4285C139.404 63.5007 139.393 63.5957 139.396 63.7022C139.396 63.8124 139.419 63.9379 139.469 64.0747C139.564 64.337 139.78 64.6602 140.182 64.797C140.573 64.9263 141.105 64.8236 141.462 64.4359C141.64 64.242 141.747 63.9683 141.758 63.687C141.758 63.687 141.758 63.687 141.758 63.6832C141.773 63.398 141.713 63.1091 141.618 62.8278C141.428 62.2728 141.097 61.7216 141.135 61.0867C141.158 60.4557 141.462 59.8056 141.993 59.3646C142.255 59.1441 142.567 58.9693 142.905 58.8552C143.243 58.7374 143.607 58.7032 143.983 58.6727C144.359 58.6423 144.739 58.6233 145.107 58.5207C145.475 58.4219 145.828 58.2128 146.041 57.8934C146.257 57.5779 146.337 57.2054 146.348 56.8518C146.348 56.8518 146.348 56.8518 146.348 56.848C146.364 56.4945 146.307 56.1485 146.227 55.8292C146.071 55.1906 145.866 54.6013 145.878 54.0311C145.885 53.4647 146.079 52.9476 146.352 52.5523C146.626 52.1493 146.99 51.8908 147.309 51.6627C147.499 51.5297 147.67 51.4042 147.822 51.2864C147.818 51.294 147.814 51.3016 147.81 51.3054C147.279 51.9554 146.88 52.712 146.633 53.5179C146.629 53.5369 146.622 53.5521 146.618 53.5711C146.607 53.6091 146.595 53.6471 146.584 53.6813C146.409 54.2478 146.288 54.9168 146.303 55.6505C146.307 56.1067 146.39 56.5895 146.481 57.0647C146.504 57.194 146.523 57.3232 146.538 57.4563C146.538 57.5095 146.546 57.5627 146.546 57.6159C146.55 57.863 146.534 58.1063 146.478 58.3344C146.462 58.3876 146.443 58.4371 146.417 58.4865C146.208 58.9198 145.775 59.1936 145.354 59.4102C144.928 59.6345 144.484 59.817 144.105 60.0869C143.717 60.3416 143.425 60.7446 143.341 61.1551C143.25 61.5657 143.269 61.9497 143.288 62.288C143.345 62.9685 143.398 63.5121 143.353 63.8846C143.319 64.2458 143.235 64.4321 143.25 64.4549C142.878 65.3444 141.902 65.9717 140.934 65.8767C140.934 65.8767 140.938 65.8766 140.942 65.8804C140.942 65.8804 140.938 65.8804 140.934 65.8804C141.386 66.2302 141.876 66.5267 142.385 66.7814C142.442 66.8118 142.498 66.8422 142.559 66.8688C142.669 66.9221 142.787 66.9715 142.901 67.0209C142.988 67.0589 143.072 67.0969 143.159 67.1312C143.186 67.1426 143.216 67.154 143.243 67.1654C143.972 67.4391 144.739 67.6292 145.513 67.7128C145.919 67.1578 146.326 66.6065 146.732 66.0515C146.269 66.6332 146.421 67.5379 146.903 68.1081C147.385 68.6784 148.11 68.9749 148.824 69.1802C149.815 69.4653 150.84 69.5983 151.869 69.6021C151.861 69.777 151.85 70.0203 151.839 70.3282V70.3435C151.827 70.659 151.812 71.0429 151.793 71.5105L151.774 72.613C151.763 72.5902 151.744 72.5749 151.732 72.5521L151.702 72.6396L151.672 70.7198L150.487 72.6738L145.426 74.107C145.426 74.107 145.441 74.0917 145.441 74.0879C145.43 74.0613 145.221 74.1032 144.917 74.2628C144.613 74.4225 144.23 74.7152 143.911 75.1372C143.596 75.5591 143.417 76.0115 143.349 76.3461C143.281 76.6844 143.296 76.8973 143.326 76.8973C143.341 76.8973 143.357 76.8593 143.376 76.7984L140.573 87.5454C140.52 87.4389 140.475 87.3629 140.448 87.3211L138.724 81.5998L137.631 81.9343L136.78 80.4593C136.78 80.4593 136.807 80.3643 136.849 80.216C136.891 80.1818 137.05 79.8625 137.225 79.3379C137.411 78.7714 137.597 77.9579 137.654 77.0417C137.707 76.1256 137.62 75.2968 137.502 74.7114C137.384 74.126 137.251 73.7762 137.225 73.7838C137.164 73.7952 137.411 74.7494 137.441 76.0686C137.327 75.179 137.168 74.1146 137.168 74.1146L136.792 73.5405C136.792 73.5405 136.765 73.4873 136.708 73.4113L136.663 73.3429L135.296 68.8076C135.296 68.8076 134.939 68.6023 134.597 68.9559C134.491 69.0661 134.453 69.3436 134.449 69.6744C134.442 70.3701 134.597 71.29 134.609 71.3585L133.789 68.9065C133.352 68.8494 133.124 69.2372 133.06 69.4881C132.995 69.739 134.028 74.1982 134.028 74.1982C134.028 74.1982 134.111 74.5327 133.91 74.5936C133.705 74.6544 132.942 70.9821 132.915 70.8262C132.889 70.6704 132.539 70.5145 132.539 70.5145C132.069 70.5677 131.924 70.9935 131.951 71.6055C131.974 72.2176 132.756 75.5135 132.756 75.5135L132.315 75.7492C132.012 75.696 130.945 73.5215 130.945 73.5215C130.945 73.5215 130.531 73.4569 130.349 73.4911C129.551 73.628 131.336 76.9391 131.336 76.9391C131.336 76.9391 131.875 79.9005 131.936 80.3985C131.996 80.8965 132.201 81.6378 132.517 81.9077C132.668 82.0369 133.006 82.6566 133.31 83.2534L132.612 83.4663L136.651 96.4638C137.433 99.2769 140.824 100.516 143.444 99.2351C144.112 98.9081 144.708 98.4215 145.16 97.7639C145.38 101.246 145.574 104.322 145.654 105.656C145.654 105.785 145.661 105.895 145.665 105.994C145.673 106.169 145.68 106.26 145.688 106.26C145.688 106.287 145.688 106.31 145.688 106.325C145.714 107.298 140.904 122.196 141.249 122.998C141.359 123.249 142.043 123.375 142.863 123.489C141.671 130.012 140.387 137.638 139.366 145.234C137.168 161.58 136.492 179.231 136.492 179.231L136.256 180.941C136.215 180.926 136.173 180.911 136.131 180.896L136.139 181.367C136.139 181.367 135.474 181.66 134.544 182.112C134.111 182.321 133.625 182.561 133.12 182.823C133.09 182.815 133.067 182.819 133.06 182.831C133.06 182.838 133.06 182.846 133.06 182.854C131.484 183.671 129.745 184.678 128.97 185.488C128.781 185.617 128.5 185.872 128.557 186.206L143.622 185.891L143.303 180.622C143.265 180.641 143.231 180.656 143.193 180.675C143.296 180.28 143.402 179.85 143.505 179.447L144.34 179.474C144.34 179.474 148.539 159.159 151.842 144.546C154.056 134.749 156.027 128.324 156.938 125.545L156.964 125.705L155.742 180.622H157.097L157.124 181.109C156.763 181.257 156.52 181.603 156.497 182.002L156.425 183.333L156.414 183.321L156.399 183.762C156.387 183.842 156.387 183.914 156.391 183.983V184.024C156.383 184.062 156.399 184.119 156.421 184.188C156.475 184.378 156.585 184.526 156.706 184.705C156.729 184.739 156.755 184.777 156.778 184.811C157.428 185.777 159.17 187.906 163.24 192.289C163.442 192.506 163.719 192.616 164.004 192.616C164.053 192.616 164.099 192.616 164.148 192.608C164.159 192.608 164.171 192.608 164.178 192.608C164.243 192.597 164.307 192.585 164.368 192.563C164.877 192.388 165.146 191.81 165.033 191.27L164.52 188.902C164.577 188.902 164.615 188.902 164.619 188.883C164.63 188.868 164.581 188.83 164.493 188.792L164.106 187.009C164.106 187.009 164.129 187.005 164.129 186.997C164.129 186.99 164.118 186.974 164.095 186.955L163.248 183.04C163.51 182.835 163.707 182.557 163.81 182.257C163.852 182.101 163.871 181.915 163.768 181.751C163.666 181.584 163.453 181.546 163.309 181.591C163.104 181.652 162.967 181.77 162.846 181.888L162.838 181.869L162.948 180.626H163.647C163.647 180.626 164.061 178.451 164.717 174.946C164.725 174.946 164.752 174.84 164.793 174.635C164.835 174.407 164.892 174.106 164.964 173.734C165.116 172.924 165.325 171.799 165.583 170.419C166.115 167.621 166.897 163.77 167.766 159.512C168.636 155.254 169.395 151.392 169.885 148.587C170.132 147.184 170.318 146.047 170.432 145.256C170.485 144.88 170.527 144.58 170.561 144.348C170.587 144.139 170.599 144.028 170.591 144.028C170.583 144.028 170.557 144.135 170.515 144.34C170.473 144.568 170.416 144.869 170.344 145.241C170.192 146.051 169.984 147.176 169.725 148.556C169.312 150.742 168.742 153.578 168.097 156.745C169.672 148.134 171.32 138.896 172.421 132.16C172.463 132.301 172.573 132.555 172.85 132.559C173.234 132.567 173.477 131.993 173.477 131.993L173.883 126.64C173.883 126.64 173.788 129.613 173.993 129.761C174.266 129.963 174.506 129.887 174.589 129.655C174.756 129.187 174.938 126.511 174.938 126.511L175.007 123.12C175.254 123.017 175.398 122.953 175.398 122.953L175.033 121.683V121.425L175.087 120.82C175.557 120.908 175.945 120.976 176.241 121.029C176.396 121.056 176.522 121.075 176.624 121.094C176.712 121.105 176.757 121.109 176.757 121.105C176.757 121.105 176.731 121.094 176.689 121.082L176.757 121.098V121.109C176.757 121.109 176.757 121.101 176.757 121.098L176.852 121.117C176.852 121.117 177.125 118.205 177.452 114.62C177.444 114.734 177.437 114.833 177.429 114.909C177.425 114.996 177.425 115.038 177.429 115.042C177.433 115.042 177.441 115 177.456 114.913C177.467 114.814 177.486 114.688 177.505 114.532C177.547 114.179 177.604 113.688 177.68 113.065C177.82 111.773 178.025 109.929 178.272 107.659C178.394 106.515 178.526 105.264 178.671 103.926C178.842 102.588 178.906 101.117 178.694 99.6038V99.5886ZM163.358 181.766C163.461 181.74 163.559 181.77 163.609 181.854C163.658 181.934 163.654 182.067 163.616 182.188C163.537 182.409 163.385 182.622 163.184 182.796L162.91 182.051C163.039 181.93 163.187 181.808 163.354 181.77L163.358 181.766ZM167.227 100.44L168.594 92.7307C168.605 92.7915 168.617 92.8447 168.628 92.9093C169.012 94.8861 169.551 97.6536 170.185 100.9C170.109 102.672 170.025 104.591 169.938 106.599L169.429 105.439L167.231 100.44H167.227ZM166.885 54.2972C166.885 54.2668 166.885 54.2326 166.885 54.2022C166.885 54.1679 166.885 54.1337 166.889 54.0957C166.889 54.282 166.901 54.4721 166.927 54.6621C166.901 54.5557 166.885 54.4378 166.882 54.2972H166.885ZM173.04 76.4943C172.888 76.27 172.748 76.0647 172.619 75.8861C172.733 76.0381 172.846 76.194 172.957 76.3537C172.987 76.3993 173.013 76.4487 173.04 76.4943ZM164.668 49.9444C164.25 49.762 163.81 49.6175 163.377 49.4997C163.237 49.4616 163.092 49.4198 162.948 49.3818C163.271 49.4388 163.894 49.5605 164.668 49.9444ZM145.376 74.145C145.376 74.145 145.373 74.1754 145.369 74.1982C144.913 74.4377 144.515 74.7722 144.188 75.1752C144.18 75.1866 144.169 75.198 144.161 75.2094C144.139 75.236 144.116 75.2626 144.097 75.2892C144.105 75.2778 144.112 75.2664 144.12 75.255C144.587 74.6202 145.164 74.2894 145.376 74.145ZM143.968 75.4755C143.968 75.4755 143.949 75.4983 143.941 75.5097C143.953 75.4907 143.972 75.4679 143.983 75.4489C143.975 75.4565 143.972 75.4679 143.968 75.4755ZM143.937 75.5173C143.937 75.5173 143.918 75.5553 143.907 75.5706C143.899 75.5858 143.888 75.5972 143.881 75.6124C143.899 75.5782 143.918 75.5477 143.937 75.5173ZM178.356 105.15C178.394 104.728 178.428 104.306 178.466 103.892C178.515 103.322 178.564 102.763 178.614 102.204C178.595 102.782 178.545 103.348 178.481 103.896C178.439 104.325 178.397 104.743 178.356 105.154V105.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.202 133.168C243.164 132.157 242.336 131.354 241.326 131.354L234.503 131.343C234.207 129.876 233.808 128.351 233.311 127.237C233.66 126.682 233.945 126.2 233.945 126.2L234.849 120.615C235.046 120.649 235.232 120.684 235.388 120.714C235.745 120.775 235.938 120.801 235.938 120.79C235.938 120.79 238.554 107.933 239.617 103.447C239.777 102.767 240.122 100.767 240.145 100.068C240.168 99.4444 240.141 98.513 239.978 97.1558C239.602 94.012 234.666 76.4071 234.245 74.9055L234.283 74.7952L224.81 69.8L223.652 68.2034L222.972 67.0097L223.428 59.8856C224.263 59.9921 225.896 59.8476 226.01 57.6693C226.097 56.0119 225.216 55.5405 224.415 55.4454C224.415 55.4454 224.411 55.4454 224.407 55.4454C224.571 55.1527 224.711 54.784 224.768 54.2898C224.924 52.9668 225.034 51.4766 225 50.1537C225.098 49.975 225.11 49.8344 225.102 49.7736C225.607 49.766 226.066 49.2451 226.07 48.7129C226.07 48.1047 225.63 47.5687 225.11 47.2569C225.482 46.6183 225.436 45.7591 224.996 45.1661C224.555 44.5731 223.747 44.2803 223.029 44.4514C222.729 43.6683 222.03 43.0487 221.218 42.8434C220.637 42.6989 220.007 42.7711 219.464 43.0258C219.464 43.0144 219.46 43.003 219.456 42.9916C219.464 42.9916 219.468 42.984 219.475 42.984C219.608 42.9308 219.684 42.9232 219.684 42.9118C219.684 42.9042 219.604 42.8966 219.46 42.9384C219.452 42.9384 219.445 42.9422 219.441 42.946C219.414 42.8662 219.388 42.7902 219.354 42.7179C219.001 42.0032 218.154 41.5661 217.368 41.6915C216.461 40.9426 215.025 40.9388 214.114 41.6877C213.427 41.2619 212.516 41.2239 211.798 41.5965C211.08 41.9652 210.583 42.7293 210.53 43.5391C209.725 43.3946 208.848 43.8128 208.457 44.5313C208.066 45.2497 208.187 46.2153 208.745 46.8122C207.861 47.0783 207.261 48.0743 207.439 48.9828C207.603 49.8116 208.389 50.4578 209.224 50.4997C209.212 50.5871 209.193 50.6745 209.186 50.762C208.795 54.6281 208.411 58.901 208.396 60.9805C208.362 65.2838 212.641 66.0403 212.641 66.0403L212.649 66.9147L212.55 67.0135L212.588 66.9337L209.695 68.3212L201.661 69.9635C200.67 70.5185 199.641 71.7084 197.488 75.5822L192.305 81.5658C192.263 81.3339 192.225 81.1438 192.191 80.9993L191.91 72.195H191.629V70.5603L190.942 70.5451L190.452 68.8877C190.452 68.8877 192.02 66.1087 192.146 65.5309C192.271 64.9531 192.518 62.1437 192.518 62.1437L192.26 61.4252C192.26 61.4252 192.248 61.3606 192.203 61.2656L192.172 61.1782L191.872 55.9244C191.872 55.9244 191.542 55.6089 191.083 55.9016C190.623 56.1943 190.471 58.5057 190.471 58.5057L190.221 55.6355C189.761 55.4568 189.416 55.818 189.283 56.0727C189.15 56.3274 189.108 61.41 189.108 61.41C189.108 61.41 189.112 61.794 188.877 61.8054C188.641 61.8206 188.77 57.6541 188.782 57.4755C188.793 57.3006 188.459 57.0421 188.459 57.0421C187.935 56.9775 187.673 57.4032 187.54 58.0685C187.407 58.7376 187.396 62.4973 187.396 62.4973L186.857 62.6379C186.629 62.5353 186.253 61.1097 186.063 60.3494C185.984 60.0187 185.725 59.7564 185.395 59.6956C185.368 59.6918 185.342 59.688 185.319 59.6842C184.423 59.6233 185.49 63.6644 185.49 63.6644C185.49 63.6644 185.304 67.0021 185.239 67.5571C185.175 68.1121 185.205 68.9675 185.475 69.3362C185.57 69.4693 185.703 69.9065 185.835 70.4121L184.985 70.3931L184.955 72.0505H184.769C184.769 72.0505 184.681 82.7062 184.769 85.4053C184.879 88.7811 185.847 92.7689 190.828 92.4153C194.215 92.1758 198.486 87.9447 200.601 85.603C200.62 85.8767 200.639 86.1504 200.662 86.4279C200.958 90.5374 201.243 94.0842 201.406 95.7683L201.501 97.7185L199.789 106.131H199.766L199.743 106.165C199.288 106.926 198.779 107.777 198.243 108.678L198.183 108.777L198.297 108.789C198.376 108.796 198.46 108.804 198.543 108.811C198.775 108.83 199.003 108.853 199.227 108.872L196.85 120.531C196.85 120.531 197.078 120.649 197.511 120.79C197.943 120.927 198.581 121.121 199.39 121.254C199.793 121.326 200.244 121.368 200.73 121.364C200.806 121.364 200.882 121.36 200.962 121.353C200.996 121.353 201.034 121.349 201.068 121.345C201.095 121.345 201.125 121.341 201.152 121.337C201.152 121.356 201.152 121.372 201.152 121.391C201.319 123.561 208.632 183.587 208.632 183.587H210.143V184.249C210.101 184.279 210.082 184.306 210.09 184.321C210.093 184.333 210.112 184.34 210.135 184.344L210.124 186.104C209.968 186.096 209.865 186.131 209.873 186.161C209.873 186.195 209.949 186.226 210.067 186.271C209.896 186.328 209.307 186.522 208.514 186.804C208.339 186.731 208.202 186.731 208.202 186.769C208.195 186.796 208.233 186.83 208.297 186.883C207.853 187.043 207.352 187.229 206.836 187.431C206.737 187.359 206.653 187.336 206.638 187.362C206.623 187.385 206.638 187.427 206.676 187.492C204.998 188.149 203.16 188.97 202.276 189.685C202.074 189.788 201.702 190.031 201.744 190.396L217.391 191.073L217.751 183.584H218.507L216.871 150.324C217.19 150.59 217.592 150.757 218.044 150.761L221.579 150.803C221.989 152.886 222.281 154.51 222.372 155.3C222.767 158.801 227.608 186.328 227.608 186.328L228.888 186.313L228.933 186.83C228.865 186.899 228.831 186.948 228.838 186.959C228.846 186.971 228.884 186.959 228.941 186.929L229.169 189.529C229.096 189.571 229.058 189.605 229.066 189.62C229.074 189.636 229.112 189.632 229.176 189.62V189.628L228.432 193.422C228.409 193.437 228.398 193.452 228.398 193.46C228.398 193.468 228.409 193.468 228.421 193.471L228.094 195.144C228.014 195.182 227.969 195.216 227.976 195.232C227.98 195.247 228.018 195.251 228.071 195.247L227.623 197.524C227.513 198.094 227.904 198.638 228.481 198.71C228.812 198.759 229.146 198.641 229.37 198.394C233.231 194.14 234.86 192.053 235.429 191.286C235.543 191.133 235.623 190.962 235.672 190.78C235.722 190.673 235.748 190.586 235.741 190.533C235.733 190.495 235.729 190.426 235.726 190.347C235.726 190.328 235.726 190.305 235.726 190.286L235.699 189.875C235.665 189.077 235.634 187.701 235.608 186.233L236.918 186.218L233.474 150.936L241.835 151.031C242.898 151.043 243.76 150.168 243.737 149.104C243.65 145.279 243.346 136.844 243.209 133.137L243.202 133.168ZM229.093 90.6324L229.131 90.7655C228.762 92.8031 228.44 94.6506 228.181 96.1446L229.005 90.8947L229.093 90.6324ZM229.279 91.2863L231.64 99.528C231.64 99.528 231.61 99.623 231.572 99.8017C231.534 100.007 231.481 100.273 231.42 100.592C231.291 101.315 231.116 102.303 230.904 103.516C230.634 105.135 230.3 107.139 229.928 109.366L227.585 99.9271C227.642 99.9385 228.367 96.2359 229.279 91.2863ZM232.7 131.343H231.424L231.158 128.773C231.405 128.891 231.838 129.039 232.164 128.785C232.206 128.75 232.259 128.697 232.316 128.636C232.438 129.419 232.574 130.374 232.703 131.339L232.7 131.343ZM232.62 120.22V120.205C233.06 120.288 233.47 120.368 233.839 120.44C234.199 120.505 234.514 120.562 234.795 120.611L232.62 120.22ZM225.068 49.7774C225.057 49.8192 225.034 49.899 224.984 49.9979C224.984 49.918 224.977 49.842 224.973 49.7622C225.003 49.766 225.038 49.7736 225.068 49.7736V49.7774ZM200.875 86.4279C200.848 86.0744 200.825 85.7246 200.799 85.3787C200.825 85.3483 200.852 85.3179 200.878 85.2913L201.053 88.9293C200.996 88.1272 200.939 87.2909 200.875 86.4279ZM216.726 133.137L216.423 141.634L215.713 127.192L216.521 127.367C216.521 127.367 216.909 129.096 217.486 131.704C217.045 132.035 216.749 132.548 216.726 133.137Z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 243,
    height: 176
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.305 4.18164H5.69913C2.55374 4.18164 0.00390625 6.73464 0.00390625 9.88393V174.11C0.00390625 177.259 2.55374 179.812 5.69913 179.812H237.305C240.45 179.812 243 177.259 243 174.11V9.88393C243 6.73464 240.45 4.18164 237.305 4.18164Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_35_124377)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1363 81.231L80.1546 81.2652L74.5771 70.3244L74.6264 70.2826L66.786 54.9814C66.786 54.9814 59.4316 69.8606 59.1127 70.0431C58.919 70.1533 61.3566 72.9209 63.3423 75.1296C62.8981 75.4413 62.6057 75.6238 62.5108 75.6314C67.4353 82.725 73.7646 91.9095 75.0251 92.1832C76.8476 92.5786 102.142 89.4879 102.142 89.4879L98.1363 81.2348V81.231Z",
    fill: "#09363F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5108 75.6313C62.5108 75.6313 62.4881 75.6011 62.4805 75.5859C62.4654 75.6237 62.4805 75.6351 62.5108 75.6313Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 54,
    width: 44,
    height: 39
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1363 81.231L80.1546 81.2652L74.5771 70.3244L74.6264 70.2826L66.786 54.9814C66.786 54.9814 59.4316 69.8606 59.1127 70.0431C58.919 70.1533 61.3566 72.9209 63.3423 75.1296C62.8981 75.4413 62.6057 75.6238 62.5108 75.6314C67.4353 82.725 73.7646 91.9095 75.0251 92.1832C76.8476 92.5786 102.142 89.4879 102.142 89.4879L98.1363 81.2348V81.231Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_35_124377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3177 54.4227V58.6653L60.1379 58.1939L60.1417 58.1901V53.9475L58.0989 52.769L57.2788 53.2442L59.3177 54.4227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8801 59.6004V55.354L56.0599 55.8292H56.0562V60.0756L58.0989 61.2541L58.9228 60.7789L56.8801 59.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8094 49.477L61.7704 50.6556V59.1331L59.7277 60.3116L58.9038 59.8364L60.9465 58.6579V54.4115V50.1803L62.9892 48.998V49.0018H62.993L63.8094 49.477Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3994 54.8904V50.644L62.5792 51.1192H62.5754V55.3656L64.6182 56.5441L65.4421 56.0689L63.3994 54.8904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 50.1803V54.4229L66.6569 55.3619V59.6083L65.833 59.1331L65.8368 55.3657V54.8867L67.4657 53.9477V49.7051L68.2858 50.1803Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 54.4229L66.657 55.3694",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4658 53.9478L65.8369 54.8868",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7235 54.4227V58.6653L71.5436 58.1939L71.5474 58.1901V53.9475L69.5085 52.769L68.6846 53.2442L70.7235 54.4227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2897 59.6004V55.354L67.4696 55.8292H67.4658V60.0756L69.5085 61.2541L70.3287 60.7789L68.2897 59.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0947 54.8866V59.133L69.5086 59.3725L69.9149 59.1368L69.9186 59.133V54.8866L69.5086 54.6509L69.1099 54.879L69.0947 54.8866Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2188 49.477L73.1761 50.6556V54.8982V59.1331L71.1371 60.3116L70.3132 59.8364L72.356 58.6579V54.4115V50.1803L74.3949 48.998L74.3987 49.0018L75.2188 49.477Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8088 54.8904V50.644L73.9887 51.1192H73.9849V55.3656L76.0276 56.5441L76.8477 56.0689L74.8088 54.8904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6952 50.1803V54.4191L78.0663 55.3619V59.6083L77.2424 59.1331L77.2462 55.3657V54.8867L78.8751 53.9477V49.7051L79.6952 50.1803Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 54.4189V54.4228L78.0664 55.3693",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8752 53.9478L77.2463 54.8868",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1329 54.4227V58.6653L82.953 58.1939L82.9568 58.1901V53.9475L80.9141 52.769L80.094 53.2442L82.1329 54.4227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 59.6004V55.354L78.8751 55.8292H78.8713V60.0756L80.914 61.2541L81.738 60.7789L79.6953 59.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5042 54.8866V59.133L80.9142 59.3725L81.3205 59.1368L81.3243 59.133V54.8866L80.9142 54.6509L80.5193 54.879L80.5042 54.8866Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6245 49.477L84.5856 50.6556V59.1331L82.5429 60.3116L81.719 59.8364L83.7617 58.6579V54.4115V50.1803L85.8044 48.998V49.0018H85.8082L86.6245 49.477Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2146 54.8904V50.644L85.3944 51.1192H85.3906V55.3656L87.4333 56.5441L88.2573 56.0689L86.2146 54.8904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 50.1803V54.4229L89.4721 55.3619V59.6083L88.6482 59.1331L88.652 55.3657V54.8867L90.2808 53.9477V49.7051L91.101 50.1803Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 54.4229L89.4722 55.3657",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2807 53.9478L88.6519 54.8868",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5384 54.4227V58.6653L94.3586 58.1939L94.3624 58.1901V53.9475L92.3234 52.769L91.4995 53.2442L93.5384 54.4227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1047 59.6004V55.354L90.2846 55.8292H90.2808V60.0756L92.3235 61.2541L93.1436 60.7789L91.1047 59.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 54.8866V59.133L92.3235 59.3725L92.7298 59.1368L92.7336 59.133V54.8866L92.3235 54.6509L91.9248 54.879L91.9097 54.8866Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.034 49.477L95.9913 50.6556V54.8982V59.1331L93.9523 60.3116L93.1284 59.8364L95.1711 58.6579V54.4115V50.1803L97.2101 48.998L97.2139 49.0018L98.034 49.477Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.624 54.8904V50.644L96.8038 51.1192H96.8V55.3656L98.8428 56.5441L99.6629 56.0689L97.624 54.8904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 50.1803V54.4191L100.882 55.3619V59.6083L100.058 59.1331V54.8867L101.69 53.9477V49.7051L102.51 50.1803Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 54.4189V54.4228L100.882 55.3693",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 53.9438L100.058 54.8867",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 59.6004V55.354L101.69 55.8292H101.687V60.0756L103.729 61.2541L104.553 60.7789L102.51 59.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3177 65.7356V69.9782L60.1379 69.5068L60.1417 69.503V65.2604L58.0989 64.0781L57.2788 64.5533L59.3177 65.7356Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8801 70.9096V66.667L56.0599 67.1384L56.0562 67.1422V71.3886L58.0989 72.5671L58.9228 72.0919L56.8801 70.9096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8094 60.7862L61.7704 61.9685V70.4461L59.7277 71.6246L58.9038 71.1494L60.9465 69.9709V65.7245V61.4933L62.9892 60.311L62.993 60.3148L63.8094 60.7862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.837 61.0258V65.2684L66.6571 64.797L66.6609 64.7932V60.5506L64.6182 59.3721L63.7981 59.8473L65.837 61.0258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3994 66.2034V61.957L62.5792 62.4322H62.5754V66.6786L64.6182 67.8571L65.4421 67.3819L63.3994 66.2034Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 61.4932V65.7358L66.6569 66.6748V70.9212L65.833 70.446L65.8368 66.6786V66.1996L67.4657 65.2606V61.0142L68.2858 61.4932Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 65.7358L66.657 66.6786",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.208 61.4896V65.736L64.6181 65.9755L65.0243 65.7398L65.0281 65.736V61.4896L64.6181 61.2539L64.2232 61.482L64.208 61.4896Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4658 65.2603L65.8369 66.1993",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7235 65.7356V69.9782L71.5436 69.5068L71.5474 69.503V65.2604L69.5085 64.0781L68.6846 64.5533L70.7235 65.7356Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2897 70.9096V66.667L67.4696 67.1384L67.4658 67.1422V71.3886L69.5085 72.5671L70.3287 72.0919L68.2897 70.9096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0947 66.1996V70.446L69.5086 70.6817L69.9149 70.446H69.9186V66.1996L69.5086 65.9639L69.1099 66.192L69.0947 66.1996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2188 60.7862L73.1761 61.9685V66.2111V70.4461L71.1371 71.6246L70.3132 71.1494L72.356 69.9709V65.7245V61.4933L74.3949 60.311H74.3987V60.3148L75.2188 60.7862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2425 61.0258V65.2684L78.0627 64.797L78.0664 64.7932V60.5506L76.0275 59.3721L75.2036 59.8473L77.2425 61.0258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8088 66.2034V61.957L73.9887 62.4322H73.9849V66.6786L76.0276 67.8571L76.8477 67.3819L74.8088 66.2034Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6952 61.4932V65.732L78.0663 66.6748V70.9212L77.2424 70.446L77.2462 66.6786V66.1996L78.8751 65.2606V61.0142L79.6952 61.4932Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 65.7319V65.7357L78.0664 66.6785",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6138 61.4896V65.736L76.0238 65.9755L76.4339 65.7398L76.4377 65.736V61.4896L76.0238 61.2539L75.629 61.482L75.6138 61.4896Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8752 65.2603L77.2463 66.1993",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1329 65.7356V69.9782L82.953 69.5068L82.9568 69.503V65.2604L80.9141 64.0781L80.094 64.5533L82.1329 65.7356Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 70.9096V66.667L78.8751 67.1384L78.8713 67.1422V71.3886L80.914 72.5671L81.738 72.0919L79.6953 70.9096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5042 66.1996V70.446L80.9142 70.6817L81.3205 70.446H81.3243V66.1996L80.9142 65.9639L80.5193 66.192L80.5042 66.1996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6245 60.7862L84.5856 61.9685V70.4461L82.5429 71.6246L81.719 71.1494L83.7617 69.9709V65.7245V61.4933L85.8044 60.311L85.8082 60.3148L86.6245 60.7862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6522 61.0258V65.2684L89.4723 64.797L89.4761 64.7932V60.5506L87.4334 59.3721L86.6133 59.8473L88.6522 61.0258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2146 66.2034V61.957L85.3944 62.4322H85.3906V66.6786L87.4333 67.8571L88.2573 67.3819L86.2146 66.2034Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 61.4932V65.7358L89.4721 66.6748V70.9212L88.6482 70.446L88.652 66.6786V66.1996L90.2808 65.2606V61.0142L91.101 61.4932Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 65.7358L89.4722 66.6786",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0232 61.4896V65.736L87.4333 65.9755L87.8395 65.7398L87.8433 65.736V61.4896L87.4333 61.2539L87.0384 61.482L87.0232 61.4896Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2807 65.2603L88.6519 66.1993",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5384 65.7356V69.9782L94.3586 69.5068L94.3624 69.503V65.2604L92.3234 64.0781L91.4995 64.5533L93.5384 65.7356Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1047 70.9096V66.667L90.2846 67.1384L90.2808 67.1422V71.3886L92.3235 72.5671L93.1436 72.0919L91.1047 70.9096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 66.1996V70.446L92.3235 70.6817L92.7298 70.446H92.7336V66.1996L92.3235 65.9639L91.9248 66.192L91.9097 66.1996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.034 60.7862L95.9913 61.9685V66.2111V70.4461L93.9523 71.6246L93.1284 71.1494L95.1711 69.9709V65.7245V61.4933L97.2101 60.311H97.2139V60.3148L98.034 60.7862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.058 61.0258V65.2684L100.878 64.797L100.882 64.7932V60.5506L98.8427 59.3721L98.0188 59.8473L100.058 61.0258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.624 66.2034V61.957L96.8038 62.4322H96.8V66.6786L98.8428 67.8571L99.6629 67.3819L97.624 66.2034Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 61.4932V65.732L100.882 66.6748V70.9212L100.058 70.446V66.1996L101.69 65.2606V61.0142L102.51 61.4932Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 65.7319V65.7357L100.882 66.6785",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.429 61.4896V65.736L98.839 65.9755L99.2491 65.7398L99.2529 65.736V61.4896L98.839 61.2539L98.4441 61.482L98.429 61.4896Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 65.2568L100.058 66.1996",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 70.9096V66.667L101.69 67.1384L101.687 67.1422V71.3886L103.729 72.5671L104.553 72.0919L102.51 70.9096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3177 77.0458V81.2922L60.1379 80.817H60.1417V76.5706L58.0989 75.3921L57.2788 75.8673L59.3177 77.0458Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8801 82.2236V77.981L56.0599 78.4524L56.0562 78.4562V82.6988L58.0989 83.8811L58.9228 83.4059L56.8801 82.2236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8094 72.0997L61.7704 73.2782V81.7558L59.7277 82.9381L58.9038 82.4629L60.9465 81.2806V77.038V72.803L62.9892 71.6245L62.993 71.6283L63.8094 72.0997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.837 72.3391V76.5818L66.6571 76.1066H66.6609V71.8639L64.6182 70.6816L63.7981 71.1568L65.837 72.3391Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3994 77.5131V73.2705L62.5792 73.7419L62.5754 73.7457V77.9921L64.6182 79.1706L65.4421 78.6954L63.3994 77.5131Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 72.8028V77.0454L66.6569 77.9882V82.2346L65.833 81.7594L65.8368 77.9882V77.513L67.4657 76.574V72.3276L68.2858 72.8028Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 77.0454V77.0492L66.657 77.992",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.208 72.8031V77.0495L64.6181 77.2852L65.0243 77.0495H65.0281V72.8031L64.6181 72.5674L64.2232 72.7955L64.208 72.8031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4658 76.5708L65.8369 77.5136",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7235 77.0458V81.2922L71.5436 80.817H71.5474V76.5706L69.5085 75.3921L68.6846 75.8673L70.7235 77.0458Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2897 82.2236V77.981L67.4696 78.4524L67.4658 78.4562V82.6988L69.5085 83.8811L70.3287 83.4059L68.2897 82.2236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0947 77.513V81.7594L69.5086 81.9951L69.9149 81.7594H69.9186V77.513L69.5086 77.2773L69.1099 77.5054L69.0947 77.513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2188 72.0997L73.1761 73.2782V77.5246V77.5208V81.7558L71.1371 82.9381L70.3132 82.4629L72.356 81.2806V77.038V72.803L74.3949 71.6245H74.3987V71.6283L75.2188 72.0997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2425 72.3391V76.5818L78.0627 76.1066H78.0664V71.8639L76.0275 70.6816L75.2036 71.1568L77.2425 72.3391Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8088 77.5131V73.2705L73.9887 73.7419L73.9849 73.7457V77.9921L76.0276 79.1706L76.8477 78.6954L74.8088 77.5131Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6952 72.8028V77.0454L78.0663 77.9882V82.2346L77.2424 81.7594L77.2462 77.992V77.513L78.8751 76.574V72.3276L79.6952 72.8028Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 77.0454V77.0492L78.0664 77.992",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6138 72.8031V77.0495L76.0238 77.2852L76.4339 77.0495H76.4377V72.8031L76.0238 72.5674L75.629 72.7955L75.6138 72.8031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8752 76.5708L77.2463 77.5136",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1329 77.0458V81.2922L82.953 80.817H82.9568V76.5706L80.9141 75.3921L80.094 75.8673L82.1329 77.0458Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 82.2236V77.981L78.8751 78.4524L78.8713 78.4562V82.6988L80.914 83.8811L81.738 83.4059L79.6953 82.2236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5042 77.513V81.7594L80.9142 81.9951L81.3205 81.7594H81.3243V77.513L80.9142 77.2773L80.5193 77.5054L80.5042 77.513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6245 72.0997L84.5856 73.2782V81.7558L82.5429 82.9381L81.719 82.4629L83.7617 81.2806V77.038V72.803L85.8044 71.6245L85.8082 71.6283L86.6245 72.0997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6522 72.3391V76.5818L89.4723 76.1066H89.4761V71.8639L87.4334 70.6816L86.6133 71.1568L88.6522 72.3391Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2146 77.5131V73.2705L85.3944 73.7419L85.3906 73.7457V77.9921L87.4333 79.1706L88.2573 78.6954L86.2146 77.5131Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 72.8028V77.0454L89.4721 77.9882V82.2346L88.6482 81.7594L88.652 77.9882V77.513L90.2808 76.574V72.3276L91.101 72.8028Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 77.0454V77.0492L89.4722 77.992",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0232 72.8031V77.0495L87.4333 77.2852L87.8395 77.0495H87.8433V72.8031L87.4333 72.5674L87.0384 72.7955L87.0232 72.8031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2807 76.5708L88.6519 77.5136",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5384 77.0458V81.2922L94.3586 80.817H94.3624V76.5706L92.3234 75.3921L91.4995 75.8673L93.5384 77.0458Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1047 82.2236V77.981L90.2846 78.4524L90.2808 78.4562V82.6988L92.3235 83.8811L93.1436 83.4059L91.1047 82.2236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 77.513V81.7594L92.3235 81.9951L92.7298 81.7594H92.7336V77.513L92.3235 77.2773L91.9248 77.5054L91.9097 77.513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.034 72.0997L95.9913 73.2782V77.5246V77.5208V81.7558L93.9523 82.9381L93.1284 82.4629L95.1711 81.2806V77.038V72.803L97.2101 71.6245H97.2139V71.6283L98.034 72.0997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.058 72.3391V76.5818L100.878 76.1066H100.882V71.8639L98.8427 70.6816L98.0188 71.1568L100.058 72.3391Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.624 77.5131V73.2705L96.8038 73.7419L96.8 73.7457V77.9921L98.8428 79.1706L99.6629 78.6954L97.624 77.5131Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 72.8028V77.0454L100.882 77.9882V82.2346L100.058 81.7594V77.513L101.69 76.574V72.3276L102.51 72.8028Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 77.0454V77.0492L100.882 77.992",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.429 72.8031V77.0495L98.839 77.2852L99.2491 77.0495H99.2529V72.8031L98.839 72.5674L98.4441 72.7955L98.429 72.8031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 76.5708L100.058 77.5136",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 82.2236V77.981L101.69 78.4524L101.687 78.4562V82.6988L103.729 83.8811L104.553 83.4059L102.51 82.2236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3177 88.3588V92.6052L60.1379 92.13H60.1417V87.8836L58.0989 86.7051L57.2788 87.1803L59.3177 88.3588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8801 93.5365V89.2939L56.0599 89.7654L56.0562 89.7691V94.0117L58.0989 95.1903L58.9228 94.7189L56.8801 93.5365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8094 83.4132L61.7704 84.5917V93.0693L59.7277 94.2516L58.9038 93.7726L60.9465 92.5941V88.3477V84.1165L62.9892 82.938H62.993L63.8094 83.4132Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.837 83.6488V87.8952L66.6571 87.42H66.6609V83.1736L64.6182 81.9951L63.7981 82.4703L65.837 83.6488Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3994 88.8266V84.584L62.5792 85.0554L62.5754 85.0592V89.3018L64.6182 90.4841L65.4421 90.0089L63.3994 88.8266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 84.1163V88.3589L66.6569 89.3017V93.5481L65.833 93.0729L65.8368 89.3017V88.8265L67.4657 87.8875V83.6411L68.2858 84.1163Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 88.3589V88.3627L66.657 89.3055",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.208 84.1166V88.363L64.6181 88.5987L65.0243 88.363H65.0281V84.1166L64.6181 83.8809L64.2232 84.109L64.208 84.1166Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4658 87.8838L65.8369 88.8266",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7235 88.3588V92.6052L71.5436 92.13H71.5474V87.8836L69.5085 86.7051L68.6846 87.1803L70.7235 88.3588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2897 93.5365V89.2939L67.4696 89.7654L67.4658 89.7691V94.0117L69.5085 95.1903L70.3287 94.7189L68.2897 93.5365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0947 88.8264V93.069L69.5086 93.3085L69.9149 93.0728L69.9186 93.069V88.8264L69.5086 88.5869L69.1099 88.8188L69.0947 88.8264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2188 83.4132L73.1761 84.5917V88.8381V88.8343V93.0693L71.1371 94.2516L70.3132 93.7726L72.356 92.5941V88.3477V84.1165L74.3949 82.938H74.3987L75.2188 83.4132Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2425 83.6488V87.8952L78.0627 87.42H78.0664V83.1736L76.0275 81.9951L75.2036 82.4703L77.2425 83.6488Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8088 88.8266V84.584L73.9887 85.0554L73.9849 85.0592V89.3018L76.0276 90.4841L76.8477 90.0089L74.8088 88.8266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6952 84.1163V88.3589L78.0663 89.3017V93.5481L77.2424 93.0729L77.2462 89.3055V88.8265L78.8751 87.8875V83.6411L79.6952 84.1163Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 88.3589V88.3627L78.0664 89.3055",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6138 84.1166V88.363L76.0238 88.5987L76.4339 88.363H76.4377V84.1166L76.0238 83.8809L75.629 84.109L75.6138 84.1166Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8752 87.8838L77.2463 88.8266",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1329 88.3588V92.6052L82.953 92.13H82.9568V87.8836L80.9141 86.7051L80.094 87.1803L82.1329 88.3588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6953 93.5365V89.2939L78.8751 89.7654L78.8713 89.7691V94.0117L80.914 95.1903L81.738 94.7189L79.6953 93.5365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5042 88.8264V93.069L80.9142 93.3085L81.3205 93.0728L81.3243 93.069V88.8264L80.9142 88.5869L80.5193 88.8188L80.5042 88.8264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6245 83.4132L84.5856 84.5917V93.0693L82.5429 94.2516L81.719 93.7726L83.7617 92.5941V88.3477V84.1165L85.8044 82.938H85.8082L86.6245 83.4132Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6522 83.6488V87.8952L89.4723 87.42H89.4761V83.1736L87.4334 81.9951L86.6133 82.4703L88.6522 83.6488Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2146 88.8266V84.584L85.3944 85.0554L85.3906 85.0592V89.3018L87.4333 90.4841L88.2573 90.0089L86.2146 88.8266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 84.1163V88.3589L89.4721 89.3017V93.5481L88.6482 93.0729L88.652 89.3017V88.8265L90.2808 87.8875V83.6411L91.101 84.1163Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.101 88.3589V88.3627L89.4722 89.3055",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0232 84.1166V88.363L87.4333 88.5987L87.8395 88.363H87.8433V84.1166L87.4333 83.8809L87.0384 84.109L87.0232 84.1166Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2807 87.8838L88.6519 88.8266",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5384 88.3588V92.6052L94.3586 92.13H94.3624V87.8836L92.3234 86.7051L91.4995 87.1803L93.5384 88.3588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1047 93.5365V89.2939L90.2846 89.7654L90.2808 89.7691V94.0117L92.3235 95.1903L93.1436 94.7189L91.1047 93.5365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 88.8264V93.069L92.3235 93.3085L92.7298 93.0728L92.7336 93.069V88.8264L92.3235 88.5869L91.9248 88.8188L91.9097 88.8264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.034 83.4132L95.9913 84.5917V88.8381V88.8343V93.0693L93.9523 94.2516L93.1284 93.7726L95.1711 92.5941V88.3477V84.1165L97.2101 82.938H97.2139L98.034 83.4132Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.058 83.6488V87.8952L100.878 87.42H100.882V83.1736L98.8427 81.9951L98.0188 82.4703L100.058 83.6488Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.624 88.8266V84.584L96.8038 85.0554L96.8 85.0592V89.3018L98.8428 90.4841L99.6629 90.0089L97.624 88.8266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 84.1163V88.3589L100.882 89.3017V93.5481L100.058 93.0729V88.8265L101.69 87.8875V83.6411L102.51 84.1163Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 88.3589V88.3627L100.882 89.3055",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.429 84.1166V88.363L98.839 88.5987L99.2491 88.363H99.2529V84.1166L98.839 83.8809L98.4441 84.109L98.429 84.1166Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 87.8838L100.058 88.8266",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 93.5365V89.2939L101.69 89.7654L101.687 89.7691V94.0117L103.729 95.1903L104.553 94.7189L102.51 93.5365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1597 96.5285C93.6522 96.9542 97.9198 95.2854 103.243 95.2854C106.926 87.0931 111.683 71.5524 111.683 71.5524L95.8999 71.1685C93.6674 76.1295 91.1463 89.298 87.1597 96.5323V96.5285Z",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5685 20.4561H52.1001C57.4574 20.4637 59.7394 22.4252 62.6592 26.9225C64.4209 29.6405 63.0313 40.6308 61.6568 44.9911C60.195 49.6366 57.4688 49.4579 57.4688 49.4579C57.4574 49.4579 57.5182 50.9861 57.5182 50.9861L54.7085 55.5214L44.5215 48.8915L43.3824 31.5907C42.8964 25.8542 45.8238 20.7868 51.5647 20.4599L51.5685 20.4561Z",
    fill: "#CCEDE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4688 49.4578C57.4688 49.4578 53.9909 49.6593 50.2852 47.3213C50.2852 47.3213 52.0089 51.4765 57.5144 50.986L57.465 49.4578H57.4688Z",
    fill: "#95C9C3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8269 35.6773C43.732 35.6355 40.0376 34.5483 40.1515 38.3271C40.2654 42.1059 44.0319 41.2087 44.0357 41.1023C44.0357 40.992 43.8269 35.6812 43.8269 35.6812V35.6773Z",
    fill: "#CCEDE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.527 28.154C62.1767 28.614 59.743 28.5342 57.7952 27.139C57.2333 26.7361 56.7093 26.2761 56.2233 25.7667C55.3462 24.8505 54.6476 23.691 53.4934 23.1588C52.0089 22.4745 50.2775 23.0524 48.7512 23.634L48.8157 23.5732C48.0222 23.9685 47.3084 24.516 46.7199 25.1812C47.2363 28.8041 46.8148 32.5638 45.4859 35.9738C45.3758 36.2551 45.167 36.4908 44.8936 36.6124C44.0241 36.9964 44.252 35.8141 43.5875 35.6126C43.0787 35.4606 42.8357 35.5746 41.8372 35.586C41.4499 34.6508 41.1462 32.0734 40.7931 30.6896C39.9312 29.8495 39.1035 28.2567 39.0237 26.9869C38.944 25.721 39.5819 24.075 39.5819 24.075C40.4665 22.2198 40.9829 21.2695 42.4295 20.7068L42.4637 20.722C43.7622 20.1556 45.3758 20.1024 46.4807 20.9843C46.6933 19.0075 48.3715 17.3957 50.2775 16.8369C52.1835 16.278 55.2741 16.4909 57.1346 17.179C58.4065 17.6504 59.6556 18.5894 61.1136 19.9617C61.3073 20.1442 61.5047 20.3305 61.7059 20.5282C61.7249 20.5434 61.7363 20.5624 61.7553 20.5776C62.1729 20.8209 62.6779 20.9235 63.2019 20.9615C64.041 21.0224 64.5535 20.7372 65.0965 20.091C65.2635 19.8933 65.4686 19.6462 65.7154 19.7146C65.871 19.7564 65.966 19.9161 66.0229 20.0682C66.3266 20.8741 66.0001 21.8169 65.4078 22.4441C65.1193 22.7482 64.7813 22.9877 64.413 23.1854C64.413 23.1854 64.9978 23.8545 65.9659 23.9723C66.4861 24.037 66.9645 24.3145 67.272 24.7364C67.4239 24.9417 67.534 25.185 67.5454 25.4625C67.61 27.0554 66.0533 27.8423 64.5194 28.1426L64.527 28.154Z",
    fill: "#09363F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0203 38.8631C51.0445 38.7414 50.213 38.27 49.6852 37.5439C49.1878 36.8596 49.0094 36.0005 49.1764 35.1185C49.5258 33.3013 51.2761 31.9974 53.167 32.1533C54.1504 32.2331 54.9857 32.6741 55.521 33.3926C56.0412 34.0921 56.2159 34.9931 56.0184 35.9359C55.616 37.8405 53.8998 39.0988 52.0241 38.8631H52.0203ZM53.2353 32.8946C53.1935 32.8908 53.148 32.8832 53.1024 32.8794C51.5799 32.7539 50.1674 33.7955 49.8865 35.2554C49.7536 35.9435 49.8865 36.5859 50.2699 37.1144C50.68 37.677 51.3331 38.042 52.1076 38.1408C53.6074 38.3271 54.9781 37.3158 55.3008 35.7876C55.4565 35.0425 55.3312 34.3658 54.9325 33.8298C54.549 33.3127 53.9491 32.9858 53.2353 32.8946Z",
    fill: "#09363F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0718 38.6653C60.096 38.5437 59.2645 38.0723 58.7367 37.3462C58.2394 36.6619 58.0609 35.8027 58.228 34.9208C58.5773 33.1036 60.3276 31.7996 62.2185 31.9555C63.2057 32.0353 64.0372 32.4763 64.5725 33.1948C65.0927 33.8943 65.2674 34.7953 65.0699 35.7381C64.6713 37.6427 62.9513 38.901 61.0756 38.6653H61.0718ZM62.2906 32.6968C62.2489 32.693 62.2033 32.6854 62.1577 32.6816C60.6352 32.5562 59.2227 33.5978 58.9418 35.0576C58.8089 35.7457 58.9418 36.3882 59.3253 36.9166C59.7353 37.4792 60.3884 37.8442 61.1629 37.943C62.6627 38.1293 64.0334 37.1181 64.3561 35.5898C64.5118 34.8447 64.3865 34.168 63.9878 33.632C63.6043 33.115 63.0044 32.7881 62.2906 32.6968Z",
    fill: "#09363F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9159 35.4072L55.54 34.7837C56.2273 34.3656 57.036 34.1717 57.8182 34.2363C58.1485 34.2629 58.4636 34.3313 58.756 34.4378L58.5054 35.1221C58.27 35.0384 58.0156 34.9814 57.7574 34.9624C57.1271 34.9092 56.4741 35.0689 55.9159 35.4072Z",
    fill: "#09363F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.489 213.269C64.489 213.269 75.1429 160.934 75.1543 159.884L56.1208 149.807L48.7512 211.228L64.4928 213.266L64.489 213.269Z",
    fill: "#09363F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5197 215.022L55.2399 124.31V104.744L33.9208 106.268C33.6664 107.032 28.2939 215.14 28.2939 215.14L30.3708 215.018H40.5235",
    fill: "#09363F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8089 103.363L75.1543 159.884L56.5005 155.353L48.8955 105.199L66.8089 103.363Z",
    fill: "#09363F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6451 127.754C69.6451 127.754 72.8877 124.968 73.2104 122.862C73.5331 120.756 69.3186 86.9067 69.3186 86.9067L67.1696 58.9274C67.1696 59.4216 67.2265 55.4034 66.5773 55.1601C64.5915 54.4188 60.5668 53.0693 60.5668 53.0693L58.2583 50.9937C58.2583 50.9937 62.4083 68.7582 63.217 73.6166L69.6451 127.754Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 50,
    width: 16,
    height: 78
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6451 127.754C69.6451 127.754 72.8877 124.968 73.2104 122.862C73.5331 120.756 69.3186 86.9067 69.3186 86.9067L67.1696 58.9274C67.1696 59.4216 67.2265 55.4034 66.5773 55.1601C64.5915 54.4188 60.5668 53.0693 60.5668 53.0693L58.2583 50.9937C58.2583 50.9937 62.4083 68.7582 63.217 73.6166L69.6451 127.754Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_35_124377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 49.8305V54.0731L59.3063 53.6017L59.3101 53.5979V49.3553L57.2674 48.1768L56.4473 48.652L58.4862 49.8305Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 55.0081V50.7617L55.2323 51.2369H55.2285V55.4833L57.2674 56.6618L58.0914 56.1866L56.0486 55.0081Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 44.8848L60.9389 46.0633V54.5409L58.9 55.7232H58.8962L58.0723 55.2442L60.115 54.0657V49.8193L60.1188 45.5881L62.1577 44.4058V44.4096H62.1615L62.9816 44.8848Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 50.2982V46.0518L61.7514 46.527H61.7476V50.7734L63.7865 51.9519L64.6104 51.4767L62.5677 50.2982Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 45.588V49.8306L65.8293 50.7696V55.016L65.0054 54.5408V50.7734V50.2944L66.6342 49.3554V45.1128L67.4582 45.588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 49.8305V54.0731L70.7121 53.6017L70.7197 53.5979V49.3553L68.677 48.1768L67.853 48.652L69.8957 49.8305Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 55.0081V50.7617L66.6381 51.2369H66.6343V55.4833L68.677 56.6618L69.5009 56.1866L67.4582 55.0081Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 50.2943V54.5407L68.677 54.7802L69.0833 54.5445L69.0871 54.5407V50.2943L68.677 50.0586L68.2784 50.2867L68.2632 50.2943Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 44.8848L72.3483 46.0633V50.3059H72.3445V54.5409L70.3056 55.7232L69.4817 55.2442L71.5244 54.0657V49.8193V45.5881L73.5671 44.4058V44.4096H73.5709L74.3873 44.8848Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 50.2982V46.0518L73.1571 46.527H73.1533V50.7734L75.196 51.9519L76.02 51.4767L73.9772 50.2982Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 61.1433V65.3859L59.3063 64.9145L59.3101 64.9107V60.6681L57.2674 59.4858L56.4473 59.961L58.4862 61.1433Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 66.3173V62.0747L55.2323 62.5499H55.2285V66.7963L57.2674 67.9748L58.0914 67.4996L56.0486 66.3173Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 56.194L60.9389 57.3763V65.8539L58.9 67.0323H58.8962L58.0723 66.5571L60.115 65.3787V61.1322L60.1188 56.9011L62.1577 55.7188L62.1615 55.7226L62.9816 56.194Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 56.4335V60.6761L65.8254 60.2047L65.8292 60.2009V55.9583L63.7864 54.7798L62.9663 55.255L65.0052 56.4335Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 61.6112V57.3647L61.7514 57.8399H61.7476V62.0864L63.7865 63.2648L64.6104 62.7896L62.5677 61.6112Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 56.9009V61.1435L65.8293 62.0825V66.3289L65.0054 65.8537V62.0863V61.6073L66.6342 60.6683V56.4219L67.4582 56.9009Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 61.1436L65.8293 62.0864",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 56.8973V61.1437L63.7865 61.3832L64.1966 61.1475L64.2004 61.1437V56.8973L63.7865 56.6616L63.3916 56.8897L63.3765 56.8973Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 60.668L65.0054 61.607",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 61.1433V65.3859L70.7121 64.9145L70.7197 64.9107V60.6681L68.677 59.4858L67.853 59.961L69.8957 61.1433Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 66.3173V62.0747L66.6381 62.5499H66.6343V66.7963L68.677 67.9748L69.5009 67.4996L67.4582 66.3173Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 61.6073V65.8537L68.677 66.0894L69.0833 65.8537H69.0871V61.6073L68.677 61.3716L68.2784 61.5997L68.2632 61.6073Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 56.194L72.3483 57.3763V61.6189H72.3445V65.8539L70.3056 67.0323L69.4817 66.5571L71.5244 65.3787V61.1322V56.9011L73.5671 55.7188L73.5709 55.7226L74.3873 56.194Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 61.6112V57.3647L73.1571 57.8399H73.1533V62.0864L75.196 63.2648L76.02 62.7896L73.9772 61.6112Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 72.453V76.6994L59.3063 76.2242H59.3101V71.9778L57.2674 70.7993L56.4473 71.2745L58.4862 72.453Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 77.6308V73.3882L55.2323 73.8596L55.2285 73.8634V78.106L57.2674 79.2883L58.0914 78.8131L56.0486 77.6308Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 67.5074L60.9389 68.6897V77.1635L58.9 78.3458H58.8962L58.0723 77.8706L60.115 76.6883V72.4457L60.1188 68.2145L62.1577 67.0322L62.1615 67.036L62.9816 67.5074Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 67.7469V71.9895L65.8254 71.5181L65.8292 71.5143V67.2717L63.7864 66.0894L62.9663 66.5646L65.0052 67.7469Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 72.9208V68.6782L61.7514 69.1496L61.7476 69.1534V73.3998L63.7865 74.5783L64.6104 74.1031L62.5677 72.9208Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 68.2144V72.4532L65.8293 73.396V77.6424L65.0054 77.1672V73.396V72.9208L66.6342 71.9818V67.7354L67.4582 68.2144Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 72.4531V72.4569L65.8293 73.3997",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 68.2108V72.4572L63.7865 72.6929L64.1966 72.4572H64.2004V68.2108L63.7865 67.9751L63.3916 68.2032L63.3765 68.2108Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 71.978L65.0054 72.9208",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 72.453V76.6994L70.7121 76.2242H70.7197V71.9778L68.677 70.7993L67.853 71.2745L69.8957 72.453Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 77.6308V73.3882L66.6381 73.8596L66.6343 73.8634V78.106L68.677 79.2883L69.5009 78.8131L67.4582 77.6308Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 72.9203V77.1667L68.677 77.4024L69.0833 77.1667H69.0871V72.9203L68.677 72.6846L68.2784 72.9127L68.2632 72.9203Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 67.5074L72.3483 68.6897V72.9323L72.3445 72.9285V77.1635L70.3056 78.3458L69.4817 77.8706L71.5244 76.6883V72.4457V68.2145L73.5671 67.0322L73.5709 67.036L74.3873 67.5074Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 72.9208V68.6782L73.1571 69.1496L73.1533 69.1534V73.3998L75.196 74.5783L76.02 74.1031L73.9772 72.9208Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 83.7665V88.0129L59.3063 87.5377H59.3101V83.2913L57.2674 82.1128L56.4473 82.588L58.4862 83.7665Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 88.9443V84.7017L55.2323 85.1731L55.2285 85.1769V89.4195L57.2674 90.598L58.0914 90.1266L56.0486 88.9443Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 78.8209L60.9389 79.9994V88.477L58.9 89.6593H58.8962L58.0723 89.1841L60.115 88.0018V83.7592L60.1188 79.5242L62.1577 78.3457H62.1615L62.9816 78.8209Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 79.0565V83.3029L65.8254 82.8277H65.8292V78.5813L63.7864 77.4028L62.9663 77.878L65.0052 79.0565Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 84.2343V79.9917L61.7514 80.4631L61.7476 80.4669V84.7095L63.7865 85.8918L64.6104 85.4166L62.5677 84.2343Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 79.524V83.7666L65.8293 84.7094V88.9558L65.0054 88.4806V84.7094V84.2342L66.6342 83.2952V79.0488L67.4582 79.524Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 83.7666V83.7704L65.8293 84.7132",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 79.5243V83.7707L63.7865 84.0064L64.1966 83.7707H64.2004V79.5243L63.7865 79.2886L63.3916 79.5167L63.3765 79.5243Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 83.2915L65.0054 84.2343",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 83.7665V88.0129L70.7121 87.5377H70.7197V83.2913L68.677 82.1128L67.853 82.588L69.8957 83.7665Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 88.9443V84.7017L66.6381 85.1731L66.6343 85.1769V89.4195L68.677 90.598L69.5009 90.1266L67.4582 88.9443Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 84.2341V88.4767L68.677 88.7162L69.0833 88.4805L69.0871 88.4767V84.2341L68.677 83.9946L68.2784 84.2265L68.2632 84.2341Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 78.8209L72.3483 79.9994V84.2458L72.3445 84.242V88.477L70.3056 89.6593L69.4817 89.1841L71.5244 88.0018V83.7592V79.5242L73.5671 78.3457H73.5709L74.3873 78.8209Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 84.2343V79.9917L73.1571 80.4631L73.1533 80.4669V84.7095L75.196 85.8918L76.02 85.4166L73.9772 84.2343Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 95.08V99.3226L59.3063 98.8512L59.3101 98.8474V94.6048L57.2674 93.4263L56.4473 93.9015L58.4862 95.08Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 100.258V96.0112L55.2323 96.4864H55.2285V100.733L57.2674 101.911L58.0914 101.436L56.0486 100.258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 90.1343L60.9389 91.3128V99.7904L58.9 100.973H58.8962L58.0723 100.494L60.115 99.3152V95.0688L60.1188 90.8376L62.1577 89.6553V89.6591H62.1615L62.9816 90.1343Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 90.37V94.6164L65.8254 94.1412H65.8292V89.8948L63.7864 88.7163L62.9663 89.1915L65.0052 90.37Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 95.5478V91.3052L61.7514 91.7766L61.7476 91.7804V96.023L63.7865 97.2015L64.6104 96.7301L62.5677 95.5478Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 90.8375V95.0801L65.8293 96.0229V100.266L65.0054 99.7903V96.0229V95.5477L66.6342 94.6049V90.3623L67.4582 90.8375Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 95.0801L65.8293 96.0267",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 90.8376V95.0802L63.7865 95.3197L64.1966 95.084L64.2004 95.0802V90.8376L63.7865 90.5981L63.3916 90.83L63.3765 90.8376Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 94.605L65.0054 95.5478",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 95.08V99.3226L70.7121 98.8512L70.7197 98.8474V94.6048L68.677 93.4263L67.853 93.9015L69.8957 95.08Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 100.258V96.0112L66.6381 96.4864H66.6343V100.733L68.677 101.911L69.5009 101.436L67.4582 100.258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 95.5476V99.7902L68.677 100.03L69.0833 99.794L69.0871 99.7902V95.5476L68.677 95.3081L68.2784 95.5362L68.2632 95.5476Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 90.1343L72.3483 91.3128V95.5554H72.3445V99.7904L70.3056 100.973L69.4817 100.494L71.5244 99.3152V95.0688V90.8376L73.5671 89.6553V89.6591H73.5709L74.3873 90.1343Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 95.5478V91.3052L73.1571 91.7766L73.1533 91.7804V96.023L75.196 97.2015L76.02 96.7301L73.9772 95.5478Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 106.393V110.636L59.3063 110.165L59.3101 110.161V105.918L57.2674 104.74L56.4473 105.215L58.4862 106.393Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 111.571V107.325L55.2323 107.8H55.2285V112.046L57.2674 113.225L58.0914 112.75L56.0486 111.571Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 101.448L60.9389 102.626V111.104L58.9 112.282H58.8962L58.0723 111.807L60.115 110.629V106.382L60.1188 102.151L62.1577 100.969V100.973H62.1615L62.9816 101.448Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 101.683V105.926L65.8254 105.455L65.8292 105.451V101.208L63.7864 100.03L62.9663 100.505L65.0052 101.683Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 106.861V102.615L61.7514 103.09H61.7476V107.336L63.7865 108.515L64.6104 108.04L62.5677 106.861Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 102.151V106.394L65.8293 107.333V111.579L65.0054 111.104V107.336V106.857L66.6342 105.918V101.676L67.4582 102.151Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 106.394L65.8293 107.34",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 102.151V106.394L63.7865 106.633L64.1966 106.398L64.2004 106.394V102.151L63.7865 101.912L63.3916 102.14L63.3765 102.151Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 105.918L65.0054 106.857",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 106.393V110.636L70.7121 110.165L70.7197 110.161V105.918L68.677 104.74L67.853 105.215L69.8957 106.393Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 111.571V107.325L66.6381 107.8H66.6343V112.046L68.677 113.225L69.5009 112.75L67.4582 111.571Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 106.857V111.104L68.677 111.343L69.0833 111.107L69.0871 111.104V106.857L68.677 106.622L68.2784 106.85L68.2632 106.857Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 101.448L72.3483 102.626V106.869H72.3445V111.104L70.3056 112.282L69.4817 111.807L71.5244 110.629V106.382V102.151L73.5671 100.969V100.973H73.5709L74.3873 101.448Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 106.861V102.615L73.1571 103.09H73.1533V107.336L75.196 108.515L76.02 108.04L73.9772 106.861Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 117.706V121.949L59.3063 121.478L59.3101 121.474V117.231L57.2674 116.049L56.4473 116.524L58.4862 117.706Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0486 122.88V118.638L55.2323 119.109L55.2285 119.113V123.359L57.2674 124.538L58.0914 124.063L56.0486 122.88Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 112.757L60.9389 113.939V122.417L58.9 123.595H58.8962L58.0723 123.12L60.115 121.942V117.695L60.1188 113.464L62.1577 112.282L62.1615 112.286L62.9816 112.757Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 112.996V117.239L65.8254 116.768L65.8292 116.764V112.521L63.7864 111.343L62.9663 111.818L65.0052 112.996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 118.174V113.928L61.7514 114.403H61.7476V118.649L63.7865 119.828L64.6104 119.353L62.5677 118.174Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 113.464V117.706L65.8293 118.645V122.892L65.0054 122.417V118.649V118.17L66.6342 117.231V112.985L67.4582 113.464Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 117.707L65.8293 118.649",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 113.46V117.707L63.7865 117.946L64.1966 117.711L64.2004 117.707V113.46L63.7865 113.225L63.3916 113.453L63.3765 113.46Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 117.231L65.0054 118.17",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 117.706V121.949L70.7121 121.478L70.7197 121.474V117.231L68.677 116.049L67.853 116.524L69.8957 117.706Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 122.88V118.638L66.6381 119.109L66.6343 119.113V123.359L68.677 124.538L69.5009 124.063L67.4582 122.88Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2632 118.17V122.417L68.677 122.652L69.0833 122.417H69.0871V118.17L68.677 117.935L68.2784 118.163L68.2632 118.17Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 112.757L72.3483 113.939V118.182H72.3445V122.417L70.3056 123.595L69.4817 123.12L71.5244 121.942V117.695V113.464L73.5671 112.282L73.5709 112.286L74.3873 112.757Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 118.174V113.928L73.1571 114.403H73.1533V118.649L75.196 119.828L76.02 119.353L73.9772 118.174Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4862 129.016V133.262L59.3063 132.787H59.3101V128.541L57.2674 127.362L56.4473 127.838L58.4862 129.016Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9816 124.07L60.9389 125.249V133.727L58.9 134.909H58.8962L58.0723 134.434L60.115 133.251V129.009L60.1188 124.778L62.1577 123.595L62.1615 123.599L62.9816 124.07Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0052 124.31V128.552L65.8254 128.081L65.8292 128.077V123.835L63.7864 122.652L62.9663 123.128L65.0052 124.31Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5677 129.484V125.241L61.7514 125.713L61.7476 125.716V129.963L63.7865 131.141L64.6104 130.666L62.5677 129.484Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4582 124.777V129.016L65.8293 129.959V134.205L65.0054 133.73V129.959V129.484L66.6342 128.545V124.298L67.4582 124.777Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3765 124.774V129.02L63.7865 129.256L64.1966 129.02H64.2004V124.774L63.7865 124.538L63.3916 124.766L63.3765 124.774Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8957 129.016V133.262L70.7121 132.787H70.7197V128.541L68.677 127.362L67.853 127.838L69.8957 129.016Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3873 124.07L72.3483 125.249V129.495L72.3445 129.492V133.727L70.3056 134.909L69.4817 134.434L71.5244 133.251V129.009V124.778L73.5671 123.595L73.5709 123.599L74.3873 124.07Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 129.484V125.241L73.1571 125.713L73.1533 125.716V129.963L75.196 131.141L76.02 130.666L73.9772 129.484Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.375 49.0282L39.8857 51.3548L26.7905 56.5134L32.6034 78.4787L31.8251 91.2176L31.0771 99.3149C31.0771 99.3149 28.3358 109.222 24.8921 121.406L34.0272 127.549L36.7306 106.313L40.7514 100.881C41.1387 100.36 41.4994 99.8243 41.8373 99.273C42.8245 97.6612 45.076 94.0041 46.8681 91.1796C49.2373 87.4541 52.2823 78.9843 51.3787 75.369C50.475 71.7538 43.375 49.0244 43.375 49.0244V49.0282Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 49,
    width: 28,
    height: 79
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.375 49.0282L39.8857 51.3548L26.7905 56.5134L32.6034 78.4787L31.8251 91.2176L31.0771 99.3149C31.0771 99.3149 28.3358 109.222 24.8921 121.406L34.0272 127.549L36.7306 106.313L40.7514 100.881C41.1387 100.36 41.4994 99.8243 41.8373 99.273C42.8245 97.6612 45.076 94.0041 46.8681 91.1796C49.2373 87.4541 52.2823 78.9843 51.3787 75.369C50.475 71.7538 43.375 49.0244 43.375 49.0244V49.0282Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_35_124377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.944 45.3901V49.6289L24.3113 50.5717V54.8181L23.4912 54.3429V50.5755V50.0965L25.1201 49.1575V44.9111L25.944 45.3901Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 49.6289V49.6327L24.3113 50.5793",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 49.1577L23.4912 50.0967",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 49.6327V53.8753L29.1979 53.4039L29.2017 53.4001V49.1575L27.1628 47.979L26.3389 48.4542L28.3778 49.6327Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 54.8104V50.564L25.1239 51.0392H25.1201V55.2856L27.1628 56.4641L27.983 55.9889L25.944 54.8104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 50.0965V54.3429L27.1629 54.5824L27.5691 54.3467L27.5729 54.3429V50.0965L27.1629 49.8608L26.7642 50.0889L26.749 50.0965Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 44.6832L30.8304 45.8655V54.3431L28.7915 55.5216L27.9675 55.0464L30.0064 53.8679V49.6215L30.0102 45.3903L32.0492 44.208L32.053 44.2118L32.8731 44.6832Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 44.9227V49.1653L35.717 48.6939L35.7208 48.6901V44.4475L33.6818 43.269L32.8579 43.7442L34.8968 44.9227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 50.1004V45.854L31.643 46.3292H31.6392V50.5756L33.6819 51.7541L34.502 51.2789L32.4631 50.1004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 45.3901V49.6327L35.7206 50.5717V54.8181L34.8967 54.3429V50.5755V50.0965L36.5256 49.1575V44.9111L37.3495 45.3901Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 49.6328L35.7207 50.5794",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 45.3904V49.633L33.6779 49.8725L34.0879 49.6368L34.0917 49.633V45.3904L33.6779 45.1509L33.283 45.379L33.2678 45.3904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 49.1577L34.8967 50.0967",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 49.6327V53.8753L40.6073 53.4039L40.6111 53.4001V49.1575L38.5684 47.979L37.7483 48.4542L39.7872 49.6327Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 54.8104V50.564L36.5294 51.0392H36.5256V55.2856L38.5683 56.4641L39.3923 55.9889L37.3496 54.8104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 50.0965V54.3429L38.5683 54.5824L38.9745 54.3467L38.9783 54.3429V50.0965L38.5683 49.8608L38.1734 50.0889L38.1582 50.0965Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 44.6832L42.2399 45.8655V50.1081V54.3431L40.1972 55.5216L39.3733 55.0464L41.416 53.8679V49.6215V45.3903L43.4587 44.208L43.4625 44.2118L44.2826 44.6832Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 44.9227V49.1653L47.1266 48.6939L47.1304 48.6901V44.4475L45.0877 43.269L44.2676 43.7442L46.3065 44.9227Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 50.1004V45.854L43.0487 46.3292H43.0449V50.5756L45.0876 51.7541L45.9116 51.2789L43.8688 50.1004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 45.3901V49.6289L47.1263 50.5717V54.8181L46.3062 54.3429V50.5755V50.0965L47.935 49.1575V44.9111L48.7589 45.3901Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 49.6289V49.6327L47.1265 50.5793",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 45.3904V49.633L45.0875 49.8725L45.4938 49.6368L45.4976 49.633V45.3904L45.0875 45.1509L44.6927 45.379L44.6775 45.3904Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 49.1577L46.3062 50.0967",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 49.6327V53.8753L52.0129 53.4039L52.0167 53.4001V49.1575L49.9777 47.979L49.1538 48.4542L51.1927 49.6327Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 54.8104V50.564L47.9389 51.0392H47.9351V55.2856L49.9778 56.4641L50.7979 55.9889L48.759 54.8104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 50.0965V54.3429L49.9778 54.5824L50.3841 54.3467L50.3879 54.3429V50.0965L49.9778 49.8608L49.5791 50.0889L49.564 50.0965Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 44.6832L53.6456 45.8655V54.3431L51.6066 55.5216L50.7827 55.0464L52.8216 53.8679V49.6215L52.8254 45.3903L54.8644 44.208L54.8682 44.2118L55.6883 44.6832Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 56.7031V60.9419L24.3113 61.8847V66.1311L23.4912 65.6559V61.8885V61.4095L25.1201 60.4705V56.2241L25.944 56.7031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 60.9419V60.9457L24.3113 61.8885",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 60.4702L23.4912 61.4092",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 60.9456V65.1882L29.1979 64.713H29.2017V60.4666L27.1628 59.2881L26.3389 59.7633L28.3778 60.9456Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 66.1196V61.877L25.1239 62.3484L25.1201 62.3522V66.5986L27.1628 67.7771L27.983 67.3019L25.944 66.1196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 61.4095V65.6559L27.1629 65.8916L27.5691 65.6559H27.5729V61.4095L27.1629 61.1738L26.7642 61.4019L26.749 61.4095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 55.9962L30.8304 57.1785V65.6523L28.7915 66.8346L27.9675 66.3594L30.0064 65.1809V60.9345L30.0102 56.7033L32.0492 55.521L32.053 55.5248L32.8731 55.9962Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 56.2357V60.4783L35.717 60.0069L35.7208 60.0031V55.7605L33.6818 54.582L32.8579 55.0572L34.8968 56.2357Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 61.4134V57.167L31.643 57.6422H31.6392V61.8886L33.6819 63.0671L34.502 62.5919L32.4631 61.4134Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 56.7031V60.9457L35.7206 61.8847V66.1311L34.8967 65.6559V61.8885V61.4095L36.5256 60.4705V56.2241L37.3495 56.7031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 60.9458L35.7207 61.8886",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 56.6996V60.946L33.6779 61.1855L34.0879 60.946H34.0917V56.6996L33.6779 56.4639L33.283 56.692L33.2678 56.6996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 60.4702L34.8967 61.4092",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 60.9456V65.1882L40.6073 64.713H40.6111V60.4666L38.5684 59.2881L37.7483 59.7633L39.7872 60.9456Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 66.1196V61.877L36.5294 62.3484L36.5256 62.3522V66.5986L38.5683 67.7771L39.3923 67.3019L37.3496 66.1196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 61.4095V65.6559L38.5683 65.8916L38.9745 65.6559H38.9783V61.4095L38.5683 61.1738L38.1734 61.4019L38.1582 61.4095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 55.9962L42.2399 57.1785V61.4211V65.6523L40.1972 66.8346L39.3733 66.3594L41.416 65.1809V60.9345V56.7033L43.4587 55.521L43.4625 55.5248L44.2826 55.9962Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 56.2357V60.4783L47.1266 60.0069L47.1304 60.0031V55.7605L45.0877 54.582L44.2676 55.0572L46.3065 56.2357Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 61.4134V57.167L43.0487 57.6422H43.0449V61.8886L45.0876 63.0671L45.9116 62.5919L43.8688 61.4134Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 56.7031V60.9419L47.1263 61.8847V66.1311L46.3062 65.6559V61.8885V61.4095L47.935 60.4705V56.2241L48.7589 56.7031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 60.9419V60.9457L47.1265 61.8885",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 56.6996V60.946L45.0875 61.1855L45.4938 60.946H45.4976V56.6996L45.0875 56.4639L44.6927 56.692L44.6775 56.6996Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 60.4702L46.3062 61.4092",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 60.9456V65.1882L52.0129 64.713H52.0167V60.4666L49.9777 59.2881L49.1538 59.7633L51.1927 60.9456Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 66.1196V61.877L47.9389 62.3484L47.9351 62.3522V66.5986L49.9778 67.7771L50.7979 67.3019L48.759 66.1196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 61.4095V65.6559L49.9778 65.8916L50.3841 65.6559H50.3879V61.4095L49.9778 61.1738L49.5791 61.4019L49.564 61.4095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 55.9962L53.6456 57.1785V65.6523L51.6066 66.8346L50.7827 66.3594L52.8216 65.1809V60.9345L52.8254 56.7033L54.8644 55.521L54.8682 55.5248L55.6883 55.9962Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 68.0128V72.2554L24.3113 73.1982V77.4446L23.4912 76.9694V73.202V72.723L25.1201 71.784V67.5376L25.944 68.0128Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 72.2554V72.2592L24.3113 73.202",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 71.7808L23.4912 72.7236",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 72.2558V76.5022L29.1979 76.0269H29.2017V71.7806L27.1628 70.6021L26.3389 71.0773L28.3778 72.2558Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 77.4335V73.1909L25.1239 73.6623L25.1201 73.6661V77.9087L27.1628 79.091L27.983 78.6158L25.944 77.4335Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 72.7234V76.966L27.1629 77.2055L27.5691 76.9698L27.5729 76.966V72.7234L27.1629 72.4839L26.7642 72.7158L26.749 72.7234Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 67.3097L30.8304 68.4882V76.9658L28.7915 78.1481L27.9675 77.6729L30.0064 76.4906V72.248L30.0102 68.013L32.0492 66.8345H32.053L32.8731 67.3097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 67.5491V71.7917L35.717 71.3165H35.7208V67.0701L33.6818 65.8916L32.8579 66.3668L34.8968 67.5491Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 72.7231V68.4805L31.643 68.9519L31.6392 68.9557V73.2021L33.6819 74.3806L34.502 73.9054L32.4631 72.7231Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 68.0128V72.2554L35.7206 73.1982V77.4446L34.8967 76.9694V73.1982V72.723L36.5256 71.784V67.5376L37.3495 68.0128Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 72.2554V72.2592L35.7207 73.202",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 68.013V72.2594L33.6779 72.4951L34.0879 72.2594H34.0917V68.013L33.6779 67.7773L33.283 68.0054L33.2678 68.013Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 71.7808L34.8967 72.7236",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 72.2558V76.5022L40.6073 76.0269H40.6111V71.7806L38.5684 70.6021L37.7483 71.0773L39.7872 72.2558Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 77.4335V73.1909L36.5294 73.6623L36.5256 73.6661V77.9087L38.5683 79.091L39.3923 78.6158L37.3496 77.4335Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 72.7234V76.966L38.5683 77.2055L38.9745 76.9698L38.9783 76.966V72.7234L38.5683 72.4839L38.1734 72.7158L38.1582 72.7234Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 67.3097L42.2399 68.4882V72.7346V72.7308V76.9658L40.1972 78.1481L39.3733 77.6729L41.416 76.4906V72.248V68.013L43.4587 66.8345H43.4625L44.2826 67.3097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 67.5491V71.7917L47.1266 71.3165H47.1304V67.0701L45.0877 65.8916L44.2676 66.3668L46.3065 67.5491Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 72.7231V68.4805L43.0487 68.9519L43.0449 68.9557V73.2021L45.0876 74.3806L45.9116 73.9054L43.8688 72.7231Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 68.0128V72.2554L47.1263 73.1982V77.4446L46.3062 76.9694V73.202V72.723L47.935 71.784V67.5376L48.7589 68.0128Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 72.2554V72.2592L47.1265 73.202",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 68.013V72.2594L45.0875 72.4951L45.4938 72.2594H45.4976V68.013L45.0875 67.7773L44.6927 68.0054L44.6775 68.013Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 71.7808L46.3062 72.7236",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 72.2558V76.5022L52.0129 76.0269H52.0167V71.7806L49.9777 70.6021L49.1538 71.0773L51.1927 72.2558Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 77.4335V73.1909L47.9389 73.6623L47.9351 73.6661V77.9087L49.9778 79.091L50.7979 78.6158L48.759 77.4335Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 72.7234V76.966L49.9778 77.2055L50.3841 76.9698L50.3879 76.966V72.7234L49.9778 72.4839L49.5791 72.7158L49.564 72.7234Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 67.3097L53.6456 68.4882V76.9658L51.6066 78.1481L50.7827 77.6729L52.8216 76.4906V72.248L52.8254 68.013L54.8644 66.8345H54.8682L55.6883 67.3097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 79.3263V83.5689L24.3113 84.5117V88.7543L23.4912 88.2791V84.5155V84.0365L25.1201 83.0975V78.8511L25.944 79.3263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 83.5688V83.5727L24.3113 84.5155",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 83.0938L23.4912 84.0366",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 83.5687V87.8151L29.1979 87.3399L29.2017 87.3361V83.0935L27.1628 81.915L26.3389 82.3902L28.3778 83.5687Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 88.7464V84.5L25.1239 84.9752L25.1201 84.979V89.2216L27.1628 90.4001L27.983 89.9249L25.944 88.7464Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 84.0364V88.279L27.1629 88.5185L27.5691 88.2828L27.5729 88.279V84.0364L27.1629 83.7969L26.7642 84.0288L26.749 84.0364Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 78.6232L30.8304 79.8016V88.2792L28.7915 89.4615L27.9675 88.9825L30.0064 87.804V83.5576L30.0102 79.3264L32.0492 78.1479H32.053L32.8731 78.6232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 78.8588V83.1052L35.717 82.63H35.7208V78.3836L33.6818 77.2051L32.8579 77.6803L34.8968 78.8588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 84.0365V79.7939L31.643 80.2653L31.6392 80.2691V84.5117L33.6819 85.694L34.502 85.2188L32.4631 84.0365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 79.3263V83.5689L35.7206 84.5117V88.7543L34.8967 88.2791V84.5117V84.0365L36.5256 83.0975V78.8511L37.3495 79.3263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 83.5688V83.5727L35.7207 84.5155",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 79.3264V83.569L33.6779 83.8085L34.0879 83.5728L34.0917 83.569V79.3264L33.6779 79.0869L33.283 79.3188L33.2678 79.3264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 83.0938L34.8967 84.0366",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 83.5687V87.8151L40.6073 87.3399L40.6111 87.3361V83.0935L38.5684 81.915L37.7483 82.3902L39.7872 83.5687Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 88.7464V84.5L36.5294 84.9752L36.5256 84.979V89.2216L38.5683 90.4001L39.3923 89.9249L37.3496 88.7464Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 84.0364V88.279L38.5683 88.5185L38.9745 88.2828L38.9783 88.279V84.0364L38.5683 83.7969L38.1734 84.0288L38.1582 84.0364Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 78.6232L42.2399 79.8016V84.048V84.0442V88.2792L40.1972 89.4615L39.3733 88.9825L41.416 87.804V83.5576V79.3264L43.4587 78.1479H43.4625L44.2826 78.6232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 78.8588V83.1052L47.1266 82.63H47.1304V78.3836L45.0877 77.2051L44.2676 77.6803L46.3065 78.8588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 84.0365V79.7939L43.0487 80.2653L43.0449 80.2691V84.5117L45.0876 85.694L45.9116 85.2188L43.8688 84.0365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 79.3263V83.5689L47.1263 84.5117V88.7543L46.3062 88.2791V84.5155V84.0365L47.935 83.0975V78.8511L48.7589 79.3263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 83.5688V83.5727L47.1265 84.5155",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 79.3264V83.569L45.0875 83.8085L45.4938 83.5728L45.4976 83.569V79.3264L45.0875 79.0869L44.6927 79.3188L44.6775 79.3264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 83.0938L46.3062 84.0366",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 83.5687V87.8151L52.0129 87.3399L52.0167 87.3361V83.0935L49.9777 81.915L49.1538 82.3902L51.1927 83.5687Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 88.7464V84.5L47.9389 84.9752L47.9351 84.979V89.2216L49.9778 90.4001L50.7979 89.9249L48.759 88.7464Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 84.0364V88.279L49.9778 88.5185L50.3841 88.2828L50.3879 88.279V84.0364L49.9778 83.7969L49.5791 84.0288L49.564 84.0364Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 78.6232L53.6456 79.8016V88.2792L51.6066 89.4615L50.7827 88.9825L52.8216 87.804V83.5576L52.8254 79.3264L54.8644 78.1479H54.8682L55.6883 78.6232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 90.6398V94.8824L24.3113 95.8252V100.068L23.4912 99.5926V95.8252V95.35L25.1201 94.4072V90.1646L25.944 90.6398Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 94.8823L24.3113 95.8289",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 94.4072L23.4912 95.35",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 94.8822V99.1248L29.1979 98.6534L29.2017 98.6496V94.407L27.1628 93.2285L26.3389 93.7037L28.3778 94.8822Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 100.06V95.8135L25.1239 96.2887H25.1201V100.535L27.1628 101.714L27.983 101.238L25.944 100.06Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 95.3499V99.5925L27.1629 99.8319L27.5691 99.5963L27.5729 99.5925V95.3499L27.1629 95.1104L26.7642 95.3385L26.749 95.3499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 89.9365L30.8304 91.115V99.5926L28.7915 100.775L27.9675 100.296L30.0064 99.1174V94.871L30.0102 90.6398L32.0492 89.4575V89.4613H32.053L32.8731 89.9365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 90.1723V94.4187L35.717 93.9435L35.7208 93.9396V89.6971L33.6818 88.5186L32.8579 88.9938L34.8968 90.1723Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 95.3499V91.1035L31.643 91.5787L31.6392 91.5825V95.8251L33.6819 97.0036L34.502 96.5284L32.4631 95.3499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 90.6398V94.8824L35.7206 95.8252V100.068L34.8967 99.5926V95.8252V95.35L36.5256 94.4072V90.1646L37.3495 90.6398Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 94.8823L35.7207 95.8289",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 90.6399V94.8825L33.6779 95.122L34.0879 94.8863L34.0917 94.8825V90.6399L33.6779 90.4004L33.283 90.6285L33.2678 90.6399Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 94.4072L34.8967 95.35",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 94.8822V99.1248L40.6073 98.6534L40.6111 98.6496V94.407L38.5684 93.2285L37.7483 93.7037L39.7872 94.8822Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 100.06V95.8135L36.5294 96.2887H36.5256V100.535L38.5683 101.714L39.3923 101.238L37.3496 100.06Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 95.3499V99.5925L38.5683 99.8319L38.9745 99.5963L38.9783 99.5925V95.3499L38.5683 95.1104L38.1734 95.3385L38.1582 95.3499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 89.9365L42.2399 91.115V95.3576V99.5926L40.1972 100.775L39.3733 100.296L41.416 99.1174V94.871V90.6398L43.4587 89.4575V89.4613H43.4625L44.2826 89.9365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 90.1723V94.4187L47.1266 93.9435L47.1304 93.9396V89.6971L45.0877 88.5186L44.2676 88.9938L46.3065 90.1723Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 95.3499V91.1035L43.0487 91.5787L43.0449 91.5825V95.8251L45.0876 97.0036L45.9116 96.5284L43.8688 95.3499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 90.6398V94.8824L47.1263 95.8252V100.068L46.3062 99.5926V95.8252V95.35L47.935 94.4072V90.1646L48.7589 90.6398Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 94.8823L47.1265 95.8289",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 90.6399V94.8825L45.0875 95.122L45.4938 94.8863L45.4976 94.8825V90.6399L45.0875 90.4004L44.6927 90.6285L44.6775 90.6399Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 94.4072L46.3062 95.35",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 94.8822V99.1248L52.0129 98.6534L52.0167 98.6496V94.407L49.9777 93.2285L49.1538 93.7037L51.1927 94.8822Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 100.06V95.8135L47.9389 96.2887H47.9351V100.535L49.9778 101.714L50.7979 101.238L48.759 100.06Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 95.3499V99.5925L49.9778 99.8319L50.3841 99.5963L50.3879 99.5925V95.3499L49.9778 95.1104L49.5791 95.3385L49.564 95.3499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 89.9365L53.6456 91.115V99.5926L51.6066 100.775L50.7827 100.296L52.8216 99.1174V94.871L52.8254 90.6398L54.8644 89.4575V89.4613H54.8682L55.6883 89.9365Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 101.953V106.191L24.3113 107.134V111.381L23.4912 110.905V107.138V106.659L25.1201 105.72V101.474L25.944 101.953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 106.191V106.195L24.3113 107.142",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 105.721L23.4912 106.66",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 106.196V110.438L29.1979 109.967L29.2017 109.963V105.72L27.1628 104.542L26.3389 105.017L28.3778 106.196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 111.373V107.127L25.1239 107.602H25.1201V111.849L27.1628 113.027L27.983 112.552L25.944 111.373Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 106.66V110.906L27.1629 111.145L27.5691 110.906H27.5729V106.66L27.1629 106.424L26.7642 106.652L26.749 106.66Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 101.246L30.8304 102.428V110.906L28.7915 112.084L27.9675 111.609L30.0064 110.43V106.184L30.0102 101.953L32.0492 100.771L32.053 100.774L32.8731 101.246Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 101.485V105.728L35.717 105.256L35.7208 105.253V101.01L33.6818 99.8315L32.8579 100.307L34.8968 101.485Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 106.663V102.417L31.643 102.892H31.6392V107.138L33.6819 108.317L34.502 107.841L32.4631 106.663Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 101.953V106.195L35.7206 107.134V111.381L34.8967 110.905V107.138V106.659L36.5256 105.72V101.474L37.3495 101.953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 106.195L35.7207 107.142",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 101.953V106.195L33.6779 106.435L34.0879 106.199L34.0917 106.195V101.953L33.6779 101.713L33.283 101.941L33.2678 101.953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 105.721L34.8967 106.66",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 106.196V110.438L40.6073 109.967L40.6111 109.963V105.72L38.5684 104.542L37.7483 105.017L39.7872 106.196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 111.373V107.127L36.5294 107.602H36.5256V111.849L38.5683 113.027L39.3923 112.552L37.3496 111.373Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 106.66V110.906L38.5683 111.145L38.9745 110.906H38.9783V106.66L38.5683 106.424L38.1734 106.652L38.1582 106.66Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 101.246L42.2399 102.428V106.671V110.906L40.1972 112.084L39.3733 111.609L41.416 110.43V106.184V101.953L43.4587 100.771L43.4625 100.774L44.2826 101.246Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 101.485V105.728L47.1266 105.256L47.1304 105.253V101.01L45.0877 99.8315L44.2676 100.307L46.3065 101.485Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 106.663V102.417L43.0487 102.892H43.0449V107.138L45.0876 108.317L45.9116 107.841L43.8688 106.663Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 101.953V106.191L47.1263 107.134V111.381L46.3062 110.905V107.138V106.659L47.935 105.72V101.474L48.7589 101.953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 106.191V106.195L47.1265 107.142",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 101.953V106.195L45.0875 106.435L45.4938 106.199L45.4976 106.195V101.953L45.0875 101.713L44.6927 101.941L44.6775 101.953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 105.721L46.3062 106.66",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 106.196V110.438L52.0129 109.967L52.0167 109.963V105.72L49.9777 104.542L49.1538 105.017L51.1927 106.196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 111.373V107.127L47.9389 107.602H47.9351V111.849L49.9778 113.027L50.7979 112.552L48.759 111.373Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 106.66V110.906L49.9778 111.145L50.3841 110.906H50.3879V106.66L49.9778 106.424L49.5791 106.652L49.564 106.66Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 101.246L53.6456 102.428V110.906L51.6066 112.084L50.7827 111.609L52.8216 110.43V106.184L52.8254 101.953L54.8644 100.771L54.8682 100.774L55.6883 101.246Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 113.266V117.505L24.3113 118.448V122.694L23.4912 122.219V118.452V117.973L25.1201 117.034V112.787L25.944 113.266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9439 117.505V117.509L24.3113 118.451",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1201 117.033L23.4912 117.972",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 117.509V121.751L29.1979 121.276H29.2017V117.03L27.1628 115.851L26.3389 116.326L28.3778 117.509Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 122.683V118.44L25.1239 118.911L25.1201 118.915V123.162L27.1628 124.34L27.983 123.865L25.944 122.683Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.749 117.973V122.219L27.1629 122.455L27.5691 122.219H27.5729V117.973L27.1629 117.737L26.7642 117.965L26.749 117.973Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 112.559L30.8304 113.741V122.215L28.7915 123.398L27.9675 122.922L30.0064 121.74V117.497L30.0102 113.266L32.0492 112.084L32.053 112.088L32.8731 112.559Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 112.799V117.041L35.717 116.57L35.7208 116.566V112.324L33.6818 111.145L32.8579 111.62L34.8968 112.799Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 117.976V113.73L31.643 114.205H31.6392V118.452L33.6819 119.63L34.502 119.155L32.4631 117.976Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 113.266V117.509L35.7206 118.448V122.694L34.8967 122.219V118.452V117.973L36.5256 117.034V112.787L37.3495 113.266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 117.509L35.7207 118.452",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 113.263V117.509L33.6779 117.748L34.0879 117.509H34.0917V113.263L33.6779 113.027L33.283 113.255L33.2678 113.263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5256 117.033L34.8967 117.972",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 117.509V121.751L40.6073 121.276H40.6111V117.03L38.5684 115.851L37.7483 116.326L39.7872 117.509Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3496 122.683V118.44L36.5294 118.911L36.5256 118.915V123.162L38.5683 124.34L39.3923 123.865L37.3496 122.683Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1582 117.973V122.219L38.5683 122.455L38.9745 122.219H38.9783V117.973L38.5683 117.737L38.1734 117.965L38.1582 117.973Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 112.559L42.2399 113.741V117.984V122.215L40.1972 123.398L39.3733 122.922L41.416 121.74V117.497V113.266L43.4587 112.084L43.4625 112.088L44.2826 112.559Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 112.799V117.041L47.1266 116.57L47.1304 116.566V112.324L45.0877 111.145L44.2676 111.62L46.3065 112.799Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 117.976V113.73L43.0487 114.205H43.0449V118.452L45.0876 119.63L45.9116 119.155L43.8688 117.976Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 113.266V117.505L47.1263 118.448V122.694L46.3062 122.219V118.452V117.973L47.935 117.034V112.787L48.7589 113.266Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7591 117.505V117.509L47.1265 118.451",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 113.263V117.509L45.0875 117.748L45.4938 117.509H45.4976V113.263L45.0875 113.027L44.6927 113.255L44.6775 113.263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 117.033L46.3062 117.972",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 117.509V121.751L52.0129 121.276H52.0167V117.03L49.9777 115.851L49.1538 116.326L51.1927 117.509Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.759 122.683V118.44L47.9389 118.911L47.9351 118.915V123.162L49.9778 124.34L50.7979 123.865L48.759 122.683Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.564 117.973V122.219L49.9778 122.455L50.3841 122.219H50.3879V117.973L49.9778 117.737L49.5791 117.965L49.564 117.973Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 112.559L53.6456 113.741V122.215L51.6066 123.398L50.7827 122.922L52.8216 121.74V117.497L52.8254 113.266L54.8644 112.084L54.8682 112.088L55.6883 112.559Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.944 124.576V128.818L24.3113 129.761V134.008L23.4912 133.532V129.765V129.286L25.1201 128.347V124.101L25.944 124.576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 128.818V133.065L29.1979 132.589H29.2017V128.343L27.1628 127.165L26.3389 127.64L28.3778 128.818Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8731 123.873L30.8304 125.051V133.529L28.7915 134.711L27.9675 134.236L30.0064 133.054V128.811L30.0102 124.576L32.0492 123.397H32.053L32.8731 123.873Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8968 124.112V128.355L35.717 127.879H35.7208V123.633L33.6818 122.455L32.8579 122.93L34.8968 124.112Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4631 129.286V125.043L31.643 125.515L31.6392 125.519V129.765L33.6819 130.944L34.502 130.468L32.4631 129.286Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3495 124.576V128.818L35.7206 129.761V134.008L34.8967 133.532V129.761V129.286L36.5256 128.347V124.101L37.3495 124.576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2678 124.576V128.822L33.6779 129.058L34.0879 128.822H34.0917V124.576L33.6779 124.34L33.283 124.568L33.2678 124.576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7872 128.818V133.065L40.6073 132.589H40.6111V128.343L38.5684 127.165L37.7483 127.64L39.7872 128.818Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2826 123.873L42.2399 125.051V129.298V129.294V133.529L40.1972 134.711L39.3733 134.236L41.416 133.054V128.811V124.576L43.4587 123.397H43.4625L44.2826 123.873Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3065 124.112V128.355L47.1266 127.879H47.1304V123.633L45.0877 122.455L44.2676 122.93L46.3065 124.112Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8688 129.286V125.043L43.0487 125.515L43.0449 125.519V129.765L45.0876 130.944L45.9116 130.468L43.8688 129.286Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7589 124.576V128.818L47.1263 129.761V134.008L46.3062 133.532V129.765V129.286L47.935 128.347V124.101L48.7589 124.576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 124.576V128.822L45.0875 129.058L45.4938 128.822H45.4976V124.576L45.0875 124.34L44.6927 124.568L44.6775 124.576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1927 128.818V133.065L52.0129 132.589H52.0167V128.343L49.9777 127.165L49.1538 127.64L51.1927 128.818Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6883 123.873L53.6456 125.051V133.529L51.6066 134.711L50.7827 134.236L52.8216 133.054V128.811L52.8254 124.576L54.8644 123.397H54.8682L55.6883 123.873Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.479 124.747C37.5393 122.272 40.1022 119.189 41.974 115.726L34.479 124.747Z",
    fill: "#375A64"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3748 49.028L46.5262 69.2788C46.4882 71.3354 46.0934 74.1827 45.2505 76.9122L39.6236 95.114C39.6236 95.114 35.2041 105.044 36.7266 106.313C39.149 106.583 44.5784 106.583 50.1521 106.313C54.2147 106.119 66.2506 103.975 66.2506 103.975C66.9986 103.865 67.5264 103.188 67.4542 102.44L65.0622 77.7106C64.2573 76.0037 63.927 72.5101 63.5891 71.267L58.6304 50.9478L57.6167 50.8147L55.4107 52.3315L54.2527 52.4228L44.5063 47.7051L43.3634 49.028H43.3748Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4399 92.4835C43.0408 84.3673 46.4086 71.1646 46.4086 71.1646C47.4566 78.0681 46.3099 85.1238 43.747 91.6206C41.6549 96.9237 39.1224 100.931 37.3797 106.359C37.3797 106.359 36.3431 106.633 36.4114 105.184C36.4798 103.732 37.8732 99.4099 38.8263 97.015C39.7793 94.62 40.4399 92.4835 40.4399 92.4835Z",
    fill: "#E1E1E1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.984 54.0576H53.797L53.1401 57.0571L55.0538 59.3761L56.9826 59.1822L57.6129 57.0343L57.0965 55.833L55.984 54.0576Z",
    fill: "#09363F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1271 95.9773C11.1702 93.5824 11.3905 90.8795 12.5523 88.5758C14.147 85.4205 16.6681 80.3188 17.1997 78.65C17.9894 76.1638 25.344 57.0839 26.7868 56.5137L33.1959 78.1216L25.7692 93.7839L34.4755 110.203L27.2044 118.03C27.2044 118.03 13.475 98.8665 12.3473 96.4944C12.2675 96.3233 12.1916 96.1522 12.1233 95.9773H12.1271Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_35_124377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 56,
    width: 24,
    height: 63
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1271 95.9773C11.1702 93.5824 11.3905 90.8795 12.5523 88.5758C14.147 85.4205 16.6681 80.3188 17.1997 78.65C17.9894 76.1638 25.344 57.0839 26.7868 56.5137L33.1959 78.1216L25.7692 93.7839L34.4755 110.203L27.2044 118.03C27.2044 118.03 13.475 98.8665 12.3473 96.4944C12.2675 96.3233 12.1916 96.1522 12.1233 95.9773H12.1271Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_35_124377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 48.6217L12.8484 49.8002V58.2778L10.8095 59.4601H10.8057L9.9856 58.9811L12.0245 57.8026V49.325L14.0672 48.1465H14.071L14.8912 48.6217Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 49.3248V53.5674L17.7349 54.5102V58.7566L16.9148 58.2814V54.5102V54.035L18.5437 53.096V48.8496L19.3676 49.3248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 53.5673V57.8137L22.6215 57.3385H22.6253V53.0921L20.5864 51.9136L19.7625 52.3888L21.8052 53.5673Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 58.745V54.5024L18.5475 54.9738L18.5437 54.9776V59.2202L20.5864 60.3987L21.4065 59.9273L19.3676 58.745Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 54.0349V58.2775L20.5865 58.517L20.9927 58.2813L20.9965 58.2775V54.0349L20.5865 53.7954L20.1878 54.0273L20.1726 54.0349Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 48.6217L24.2578 49.8002V54.0466L24.254 54.0428V58.2778L22.215 59.4601L21.3911 58.9811L23.4338 57.8026V53.5562V49.325L25.4728 48.1465H25.4766H25.4803L26.2967 48.6217Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 49.3248V53.5674L29.1442 54.5102V58.7566L28.3203 58.2814L28.3241 54.514V54.035L29.953 53.096V48.8496L30.7731 49.3248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 53.5673V57.8137L34.0309 57.3385H34.0347V53.0921L31.992 51.9136L31.1719 52.3888L33.2108 53.5673Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 58.745V54.5024L29.9569 54.9738L29.9531 54.9776V59.2202L31.992 60.3987L32.816 59.9273L30.7733 58.745Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 54.0349V58.2775L31.9921 58.517L32.3984 58.2813L32.406 58.2775V54.0349L31.9921 53.7954L31.5972 54.0273L31.582 54.0349Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 48.6217L35.6634 49.8002V58.2778L33.6245 59.4601H33.6207L32.8005 58.9811L34.8395 57.8026V49.325L36.8822 48.1465H36.886L37.7061 48.6217Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 59.9346L12.8484 61.1131V69.5907L10.8095 70.773H10.8057L9.9856 70.294L12.0245 69.1155V60.6379L14.0672 59.4556V59.4594H14.071L14.8912 59.9346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 60.1703V64.4167L17.735 63.9415L17.7388 63.9377V59.6951L15.6961 58.5166L14.876 58.9918L16.9149 60.1703Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 65.3481V61.1055L13.6571 61.5769L13.6533 61.5807V65.8233L15.696 67.0018L16.52 66.5304L14.4772 65.3481Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 60.6378V64.8804L17.7349 65.8232V70.0658L16.9148 69.5906V65.8232V65.348L18.5437 64.4052V60.1626L19.3676 60.6378Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3675 64.8804L17.7349 65.827",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 60.6379V64.8805L15.696 65.12L16.1022 64.8843L16.1098 64.8805V60.6379L15.696 60.3984L15.3011 60.6303L15.2859 60.6379Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5437 64.4058L16.9148 65.3486",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 64.8807V69.1233L22.6215 68.6519L22.6253 68.6481V64.4055L20.5864 63.2271L19.7625 63.7023L21.8052 64.8807Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 70.0584V65.812L18.5475 66.2872H18.5437V70.5336L20.5864 71.7121L21.4065 71.2369L19.3676 70.0584Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 65.3484V69.591L20.5865 69.8305L20.9927 69.5948L20.9965 69.591V65.3484L20.5865 65.1089L20.1878 65.337L20.1726 65.3484Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 59.9346L24.2578 61.1131V65.3557H24.254V69.5907L22.215 70.773L21.3911 70.294L23.4338 69.1155V64.8691V60.6379L25.4728 59.4556L25.4766 59.4594H25.4803L26.2967 59.9346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 60.1703V64.4167L29.1405 63.9415L29.1443 63.9377V59.6951L27.1054 58.5166L26.2815 58.9918L28.3242 60.1703Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 65.3481V61.1055L25.0665 61.5769L25.0627 61.5807V65.8233L27.1055 67.0018L27.9256 66.5304L25.8867 65.3481Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 60.6378V64.8804L29.1442 65.8232V70.0658L28.3203 69.5906L28.3241 65.8232V65.348L29.953 64.4052V60.1626L30.7731 60.6378Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 64.8804L29.1443 65.827",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 60.6379V64.8805L27.1053 65.12L27.5115 64.8843L27.5153 64.8805V60.6379L27.1053 60.3984L26.7066 60.6303L26.6914 60.6379Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 64.4058L28.3242 65.3486",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 64.8807V69.1233L34.0309 68.6519L34.0347 68.6481V64.4055L31.992 63.2271L31.1719 63.7023L33.2108 64.8807Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 70.0584V65.812L29.9569 66.2872H29.9531V70.5336L31.992 71.7121L32.816 71.2369L30.7733 70.0584Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 65.3484V69.591L31.9921 69.8305L32.3984 69.5948L32.406 69.591V65.3484L31.9921 65.1089L31.5972 65.337L31.582 65.3484Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 59.9346L35.6634 61.1131V69.5907L33.6245 70.773H33.6207L32.8005 70.294L34.8395 69.1155V60.6379L36.8822 59.4556V59.4594H36.886L37.7061 59.9346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 71.248L12.8484 72.4265V80.9041L10.8095 82.0826H10.8057L9.9856 81.6074L12.0245 80.4289V71.9513L14.0672 70.769V70.7728H14.071L14.8912 71.248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 71.4838V75.7264L17.735 75.255L17.7388 75.2512V71.0086L15.6961 69.8301L14.876 70.3053L16.9149 71.4838Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 76.6614V72.415L13.6571 72.8902H13.6533V77.1366L15.696 78.3152L16.52 77.8399L14.4772 76.6614Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 71.9513V76.1939L17.7349 77.1329V81.3793L16.9148 80.9041V77.1367V76.6577L18.5437 75.7187V71.4761L19.3676 71.9513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3675 76.1938L17.7349 77.1404",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 71.9514V76.194L15.696 76.4335L16.1022 76.1978L16.1098 76.194V71.9514L15.696 71.7119L15.3011 71.94L15.2859 71.9514Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5437 75.7188L16.9148 76.6577",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 76.1937V80.4363L22.6215 79.9649L22.6253 79.9611V75.7185L20.5864 74.54L19.7625 75.0152L21.8052 76.1937Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 81.3714V77.125L18.5475 77.6002H18.5437V81.8466L20.5864 83.0251L21.4065 82.5499L19.3676 81.3714Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 76.6576V80.904L20.5865 81.1435L20.9927 80.9078L20.9965 80.904V76.6576L20.5865 76.4219L20.1878 76.65L20.1726 76.6576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 71.248L24.2578 72.4265V76.6691H24.254V80.9041L22.215 82.0826L21.3911 81.6074L23.4338 80.4289V76.1825V71.9513L25.4728 70.769L25.4766 70.7728H25.4803L26.2967 71.248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 71.4838V75.7264L29.1405 75.255L29.1443 75.2512V71.0086L27.1054 69.8301L26.2815 70.3053L28.3242 71.4838Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 76.6614V72.415L25.0665 72.8902H25.0627V77.1366L27.1055 78.3152L27.9256 77.8399L25.8867 76.6614Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 71.9513V76.1901L29.1442 77.1329V81.3793L28.3203 80.9041L28.3241 77.1367V76.6577L29.953 75.7187V71.4761L30.7731 71.9513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 76.1899V76.1937L29.1443 77.1403",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 71.9514V76.194L27.1053 76.4335L27.5115 76.1978L27.5153 76.194V71.9514L27.1053 71.7119L26.7066 71.94L26.6914 71.9514Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 75.7188L28.3242 76.6577",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 76.1937V80.4363L34.0309 79.9649L34.0347 79.9611V75.7185L31.992 74.54L31.1719 75.0152L33.2108 76.1937Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 81.3714V77.125L29.9569 77.6002H29.9531V81.8466L31.992 83.0251L32.816 82.5499L30.7733 81.3714Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 76.6576V80.904L31.9921 81.1435L32.3984 80.9078L32.406 80.904V76.6576L31.9921 76.4219L31.5972 76.65L31.582 76.6576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 71.248L35.6634 72.4265V80.9041L33.6245 82.0826H33.6207L32.8005 81.6074L34.8395 80.4289V71.9513L36.8822 70.769V70.7728H36.886L37.7061 71.248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 82.5577L12.8484 83.74V92.2176L10.8095 93.3961H10.8057L9.9856 92.9209L12.0245 91.7424V83.2648L14.0672 82.0825L14.071 82.0863L14.8912 82.5577Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 82.7972V87.0398L17.735 86.5685L17.7388 86.5646V82.322L15.6961 81.1436L14.876 81.6188L16.9149 82.7972Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 87.9749V83.7285L13.6571 84.2037H13.6533V88.4501L15.696 89.6286L16.52 89.1534L14.4772 87.9749Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 83.2647V87.5073L17.7349 88.4463V92.6926L16.9148 92.2174V88.45V87.9711L18.5437 87.0321V82.7856L19.3676 83.2647Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3675 87.5073L17.7349 88.4501",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 83.2611V87.5075L15.696 87.747L16.1022 87.5113L16.1098 87.5075V83.2611L15.696 83.0254L15.3011 83.2535L15.2859 83.2611Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5437 87.0317L16.9148 87.9707",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 87.5071V91.7497L22.6215 91.2745H22.6253V87.0319L20.5864 85.8496L19.7625 86.3248L21.8052 87.5071Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 92.6811V88.4385L18.5475 88.9099L18.5437 88.9137V93.1601L20.5864 94.3386L21.4065 93.8634L19.3676 92.6811Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 87.971V92.2174L20.5865 92.4532L20.9927 92.2174H20.9965V87.971L20.5865 87.7354L20.1878 87.9634L20.1726 87.971Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 82.5577L24.2578 83.74V87.9826H24.254V92.2176L22.215 93.3961L21.3911 92.9209L23.4338 91.7424V87.496V83.2648L25.4728 82.0825H25.4766L25.4803 82.0863L26.2967 82.5577Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 82.7972V87.0398L29.1405 86.5685L29.1443 86.5646V82.322L27.1054 81.1436L26.2815 81.6188L28.3242 82.7972Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 87.9749V83.7285L25.0665 84.2037H25.0627V88.4501L27.1055 89.6286L27.9256 89.1534L25.8867 87.9749Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 83.2647V87.5034L29.1442 88.4463V92.6926L28.3203 92.2174L28.3241 88.45V87.9711L29.953 87.0321V82.7856L30.7731 83.2647Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 87.5034V87.5072L29.1443 88.45",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 83.2611V87.5075L27.1053 87.747L27.5115 87.5113L27.5153 87.5075V83.2611L27.1053 83.0254L26.7066 83.2535L26.6914 83.2611Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 87.0317L28.3242 87.9707",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 87.5071V91.7497L34.0309 91.2745H34.0347V87.0319L31.992 85.8496L31.1719 86.3248L33.2108 87.5071Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 92.6811V88.4385L29.9569 88.9099L29.9531 88.9137V93.1601L31.992 94.3386L32.816 93.8634L30.7733 92.6811Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 87.971V92.2174L31.9921 92.4532L32.3984 92.2174H32.406V87.971L31.9921 87.7354L31.5972 87.9634L31.582 87.971Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 82.5577L35.6634 83.74V92.2176L33.6245 93.3961H33.6207L32.8005 92.9209L34.8395 91.7424V83.2648L36.8822 82.0825L36.886 82.0863L37.7061 82.5577Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 93.8712L12.8484 95.0497V103.527L10.8095 104.71H10.8057L9.9856 104.234L12.0245 103.052V94.5745L14.0672 93.396L14.071 93.3998L14.8912 93.8712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 94.1106V98.3532L17.735 97.878H17.7388V93.6316L15.6961 92.4531L14.876 92.9283L16.9149 94.1106Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 99.2846V95.042L13.6571 95.5134L13.6533 95.5172V99.7636L15.696 100.942L16.52 100.467L14.4772 99.2846Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 94.5743V98.8169L17.7349 99.7597V104.006L16.9148 103.531V99.7597V99.2845L18.5437 98.3455V94.0991L19.3676 94.5743Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3675 98.8169V98.8207L17.7349 99.7635",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 94.5746V98.821L15.696 99.0567L16.1022 98.821H16.1098V94.5746L15.696 94.3389L15.3011 94.567L15.2859 94.5746Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5437 98.3418L16.9148 99.2846",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 98.8168V103.063L22.6215 102.588H22.6253V98.3416L20.5864 97.1631L19.7625 97.6383L21.8052 98.8168Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 103.995V99.752L18.5475 100.223L18.5437 100.227V104.47L20.5864 105.652L21.4065 105.177L19.3676 103.995Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 99.284V103.53L20.5865 103.766L20.9927 103.53H20.9965V99.284L20.5865 99.0483L20.1878 99.2764L20.1726 99.284Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 93.8712L24.2578 95.0497V99.2961L24.254 99.2923V103.527L22.215 104.71L21.3911 104.234L23.4338 103.052V98.8095V94.5745L25.4728 93.396H25.4766L25.4803 93.3998L26.2967 93.8712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 94.1106V98.3532L29.1405 97.878H29.1443V93.6316L27.1054 92.4531L26.2815 92.9283L28.3242 94.1106Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 99.2846V95.042L25.0665 95.5134L25.0627 95.5172V99.7636L27.1055 100.942L27.9256 100.467L25.8867 99.2846Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 94.5743V98.8169L29.1442 99.7597V104.006L28.3203 103.531L28.3241 99.7635V99.2845L29.953 98.3455V94.0991L30.7731 94.5743Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 98.8169V98.8207L29.1443 99.7635",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 94.5746V98.821L27.1053 99.0567L27.5115 98.821H27.5153V94.5746L27.1053 94.3389L26.7066 94.567L26.6914 94.5746Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 98.3418L28.3242 99.2846",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 98.8168V103.063L34.0309 102.588H34.0347V98.3416L31.992 97.1631L31.1719 97.6383L33.2108 98.8168Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 103.995V99.752L29.9569 100.223L29.9531 100.227V104.47L31.992 105.652L32.816 105.177L30.7733 103.995Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 99.284V103.53L31.9921 103.766L32.3984 103.53H32.406V99.284L31.9921 99.0483L31.5972 99.2764L31.582 99.284Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 93.8712L35.6634 95.0497V103.527L33.6245 104.71H33.6207L32.8005 104.234L34.8395 103.052V94.5745L36.8822 93.396L36.886 93.3998L37.7061 93.8712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 105.185L12.8484 106.363V114.841L10.8095 116.023H10.8057L9.9856 115.544L12.0245 114.366V105.888L14.0672 104.709H14.071L14.8912 105.185Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 105.42V109.667L17.735 109.192H17.7388V104.945L15.6961 103.767L14.876 104.242L16.9149 105.42Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 110.598V106.355L13.6571 106.827L13.6533 106.831V111.073L15.696 112.256L16.52 111.78L14.4772 110.598Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 105.888V110.13L17.7349 111.073V115.32L16.9148 114.844V111.073V110.598L18.5437 109.659V105.413L19.3676 105.888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3675 110.13V110.134L17.7349 111.077",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 105.888V110.134L15.696 110.37L16.1022 110.134H16.1098V105.888L15.696 105.652L15.3011 105.88L15.2859 105.888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5437 109.655L16.9148 110.598",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8052 110.13V114.377L22.6215 113.901H22.6253V109.655L20.5864 108.477L19.7625 108.952L21.8052 110.13Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 115.308V111.065L18.5475 111.537L18.5437 111.541V115.783L20.5864 116.962L21.4065 116.49L19.3676 115.308Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 110.598V114.841L20.5865 115.08L20.9927 114.844L20.9965 114.841V110.598L20.5865 110.358L20.1878 110.59L20.1726 110.598Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 105.185L24.2578 106.363V110.61L24.254 110.606V114.841L22.215 116.023L21.3911 115.544L23.4338 114.366V110.119V105.888L25.4728 104.709H25.4766H25.4803L26.2967 105.185Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 105.42V109.667L29.1405 109.192H29.1443V104.945L27.1054 103.767L26.2815 104.242L28.3242 105.42Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 110.598V106.355L25.0665 106.827L25.0627 106.831V111.073L27.1055 112.256L27.9256 111.78L25.8867 110.598Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 105.888V110.13L29.1442 111.073V115.32L28.3203 114.844L28.3241 111.077V110.598L29.953 109.659V105.413L30.7731 105.888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 110.13V110.134L29.1443 111.077",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 105.888V110.134L27.1053 110.37L27.5115 110.134H27.5153V105.888L27.1053 105.652L26.7066 105.88L26.6914 105.888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 109.655L28.3242 110.598",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2108 110.13V114.377L34.0309 113.901H34.0347V109.655L31.992 108.477L31.1719 108.952L33.2108 110.13Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 115.308V111.065L29.9569 111.537L29.9531 111.541V115.783L31.992 116.962L32.816 116.49L30.7733 115.308Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 110.598V114.841L31.9921 115.08L32.3984 114.844L32.406 114.841V110.598L31.9921 110.358L31.5972 110.59L31.582 110.598Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 105.185L35.6634 106.363V114.841L33.6245 116.023H33.6207L32.8005 115.544L34.8395 114.366V105.888L36.8822 104.709H36.886L37.7061 105.185Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8912 116.498L12.8484 117.676V126.154L10.8095 127.336H10.8057L9.9856 126.857L12.0245 125.678V117.201L14.0672 116.019V116.022H14.071L14.8912 116.498Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9149 116.733V120.98L17.735 120.504L17.7388 120.501V116.258L15.6961 115.08L14.876 115.555L16.9149 116.733Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 121.911V117.668L13.6571 118.14L13.6533 118.144V122.386L15.696 123.565L16.52 123.093L14.4772 121.911Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 117.201V121.443L17.7349 122.386V126.629L16.9148 126.154V122.386V121.911L18.5437 120.968V116.726L19.3676 117.201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 117.201V121.444L15.696 121.683L16.1022 121.447L16.1098 121.444V117.201L15.696 116.961L15.3011 117.193L15.2859 117.201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2967 116.498L24.2578 117.676V121.919H24.254V126.154L22.215 127.336L21.3911 126.857L23.4338 125.678V121.432V117.201L25.4728 116.019L25.4766 116.022H25.4803L26.2967 116.498Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3242 116.733V120.98L29.1405 120.504L29.1443 120.501V116.258L27.1054 115.08L26.2815 115.555L28.3242 116.733Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 121.911V117.668L25.0665 118.14L25.0627 118.144V122.386L27.1055 123.565L27.9256 123.093L25.8867 121.911Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7731 117.201V121.443L29.1442 122.386V126.629L28.3203 126.154L28.3241 122.386V121.911L29.953 120.968V116.726L30.7731 117.201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 117.201V121.444L27.1053 121.683L27.5115 121.447L27.5153 121.444V117.201L27.1053 116.961L26.7066 117.193L26.6914 117.201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7061 116.498L35.6634 117.676V126.154L33.6245 127.336H33.6207L32.8005 126.857L34.8395 125.678V117.201L36.8822 116.019V116.022H36.886L37.7061 116.498Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9803 123.208C36.5674 121.71 39.8137 117.319 40.0985 116.738C38.8835 115.947 36.8863 114.7 38.6139 114.457C40.7401 114.152 42.0159 113.194 42.2361 112.628C42.4525 112.062 42.1943 111.324 41.4578 111.636C40.9604 111.845 39.4606 112.411 37.5963 112.29C36.1687 112.195 34.2361 111.176 33.7539 111.088L28.575 116.547C28.575 116.547 32.7249 120.965 34.9803 123.212V123.208Z",
    fill: "#CCEDE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6957 72.1686C68.6957 72.1686 68.616 71.9557 68.5173 71.5603C68.4148 71.165 68.2857 70.5909 68.1452 69.8762C67.8604 68.4468 67.5415 66.4548 67.344 64.2385C67.1466 62.0221 67.1086 60.0034 67.1352 58.5474C67.1504 57.8175 67.1732 57.2283 67.2036 56.8215C67.2301 56.4147 67.2567 56.1904 67.2719 56.1904C67.2909 56.1904 67.2985 56.4185 67.3023 56.8253C67.3023 57.2853 67.3099 57.8593 67.3137 58.5474C67.3326 59.9996 67.401 62.0069 67.5946 64.2156C67.7921 66.4244 68.0806 68.4088 68.3198 69.8458C68.4375 70.5225 68.5325 71.0928 68.6122 71.5413C68.6805 71.9405 68.7109 72.1648 68.6957 72.1686Z",
    fill: "#375A64"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3451 56.7109C32.3451 56.7109 32.497 56.92 32.7362 57.323C32.8577 57.5245 32.9982 57.7716 33.1463 58.0719C33.2944 58.3684 33.4766 58.7029 33.6361 59.0907C33.9854 59.851 34.3423 60.79 34.6726 61.8468C34.9878 62.9112 35.2725 64.1011 35.4624 65.367C35.6446 66.6367 35.713 67.857 35.7168 68.9671C35.7054 70.0771 35.6332 71.0769 35.5155 71.9057C35.4738 72.3238 35.394 72.6964 35.3371 73.0233C35.2839 73.3502 35.2194 73.6316 35.1624 73.8596C35.0523 74.3158 34.9802 74.5629 34.965 74.5591C34.946 74.5553 34.984 74.2968 35.0637 73.8406C35.1055 73.6125 35.1548 73.3312 35.1966 73.0005C35.2384 72.6736 35.3029 72.301 35.3371 71.8866C35.432 71.0579 35.4814 70.0695 35.4814 68.9709C35.4662 67.8722 35.3902 66.6633 35.208 65.4088C35.0181 64.1543 34.7448 62.9759 34.4448 61.919C34.1297 60.866 33.7955 59.9308 33.469 59.1667C33.3209 58.779 33.1501 58.4406 33.0172 58.1403C32.8843 57.8362 32.7552 57.5815 32.6489 57.3762C32.4401 56.958 32.3299 56.7223 32.3451 56.7147V56.7109Z",
    fill: "#375A64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6856 93.9091C25.6477 93.9319 25.3249 93.3883 24.6833 92.6013C24.0416 91.8258 23.0658 90.788 21.7749 89.963C21.1294 89.5639 20.4118 89.37 19.7701 89.4802C19.1284 89.5791 18.5969 89.8794 18.1792 90.1569C17.3515 90.731 16.8921 91.1795 16.8617 91.1415C16.8503 91.1301 16.9528 91.0085 17.1541 90.807C17.3591 90.6055 17.6552 90.3166 18.0729 90.0086C18.4868 89.7045 19.0335 89.37 19.7283 89.2483C20.427 89.1115 21.2281 89.3243 21.9001 89.7463C23.2404 90.6017 24.2011 91.6737 24.8199 92.4911C25.1275 92.9017 25.3477 93.2552 25.4882 93.5061C25.6287 93.757 25.6932 93.9015 25.678 93.9091H25.6856Z",
    fill: "#375A64"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0794 88.7352C24.1364 88.701 24.7742 89.7198 25.2261 91.1264C25.6855 92.5292 25.7652 93.7305 25.7007 93.7343C25.6247 93.7457 25.4311 92.5824 24.9831 91.2063C24.5388 89.8301 24.0149 88.7732 24.0794 88.739V88.7352Z",
    fill: "#375A64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3328 101.96C30.3328 101.96 30.4771 102.177 30.7049 102.592C30.9441 103.048 31.2592 103.641 31.6389 104.359C32.4211 105.861 33.4918 107.956 34.6726 110.301L34.7144 110.381L34.6536 110.446C34.498 110.609 34.3309 110.78 34.1638 110.959C32.2312 112.974 30.4733 114.787 29.1899 116.091C28.5672 116.715 28.0547 117.232 27.6636 117.627C27.2991 117.984 27.0903 118.178 27.0789 118.167C27.0675 118.155 27.2497 117.939 27.5914 117.558C27.9673 117.148 28.4647 116.612 29.0608 115.966C30.31 114.627 32.049 112.795 33.9816 110.78C34.1487 110.605 34.3157 110.43 34.4714 110.271L34.4486 110.415C33.2678 108.066 32.2274 105.96 31.487 104.435C31.1377 103.702 30.8454 103.097 30.6252 102.633C30.4277 102.208 30.3252 101.968 30.3404 101.96H30.3328Z",
    fill: "#375A64"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9123 92.0501C39.9123 92.0501 39.9009 91.9018 39.9009 91.6243C39.9009 91.324 39.9085 90.9172 39.9161 90.4078C39.9389 89.3282 39.9768 87.8038 40.0186 85.9334C40.0717 84.0441 40.1135 81.7974 40.2198 79.296C40.3375 76.8022 40.5425 74.0346 41.3209 71.2329C41.7082 69.8492 42.2246 68.53 42.8738 67.3401L42.965 67.5264C42.3385 67.4314 41.7879 67.0778 41.393 66.6331C40.9944 66.1883 40.7248 65.6485 40.5729 65.1049C40.2692 64.0024 40.3261 62.9152 40.3147 61.9154C40.3147 59.9082 40.3147 58.1176 40.3147 56.6198C40.3223 55.1448 40.3299 53.9588 40.3375 53.111C40.3451 52.7195 40.3489 52.4039 40.3527 52.1682C40.3603 51.9516 40.3679 51.8413 40.3755 51.8413C40.3831 51.8413 40.3907 51.9516 40.3983 52.1682C40.4059 52.4039 40.4135 52.7195 40.4248 53.111C40.4362 53.9588 40.4552 55.1448 40.478 56.6198C40.4932 58.1214 40.5122 59.9082 40.5312 61.9154C40.5463 62.919 40.5008 63.991 40.7969 65.0402C40.945 65.561 41.1994 66.059 41.5715 66.4696C41.9398 66.884 42.4372 67.1957 42.9953 67.2793L43.1738 67.3059L43.0865 67.4656C42.4486 68.6403 41.9436 69.9404 41.5601 71.3089C40.7893 74.0765 40.5805 76.8288 40.4476 79.315C40.3299 81.8088 40.2692 84.0593 40.1932 85.9448C40.1173 87.8152 40.0566 89.3358 40.011 90.4154C39.9844 90.9248 39.9654 91.3316 39.9502 91.6319C39.9313 91.9094 39.9199 92.0539 39.9123 92.0539V92.0501Z",
    fill: "#375A64"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9882 53.3354C60.9882 53.3354 61.0337 53.4267 61.1021 53.6054C61.1742 53.8106 61.2691 54.0729 61.3868 54.3999C61.6336 55.1222 61.9791 56.122 62.4006 57.3537C62.8258 58.6196 63.3308 60.1212 63.8966 61.8015C64.1661 62.653 64.5003 63.5159 64.7546 64.4815C64.8686 64.9643 64.9293 65.4889 64.8154 66.0135C64.7053 66.5268 64.4281 67.0514 63.9383 67.3555L63.9763 67.1768C64.394 67.7927 64.8306 68.4465 65.2369 69.1308C65.8406 70.1534 66.3493 71.2178 66.6151 72.3203C66.8847 73.4227 66.8847 74.5252 66.8391 75.5478C66.7176 77.5968 66.5847 79.433 66.4784 80.9764C66.3645 82.497 66.2734 83.7401 66.2089 84.6334C66.1747 85.044 66.1443 85.3747 66.1215 85.6256C66.0987 85.8537 66.0836 85.9716 66.0722 85.9716C66.0646 85.9716 66.0608 85.8499 66.0684 85.6218C66.0798 85.3671 66.0911 85.0364 66.1063 84.6258C66.1519 83.7325 66.2164 82.4894 66.2962 80.965C66.3835 79.4101 66.486 77.574 66.6037 75.5364C66.6417 74.5214 66.6379 73.4455 66.3721 72.3773C66.1101 71.3091 65.6165 70.2675 65.0166 69.2601C64.6142 68.5796 64.1775 67.9333 63.7637 67.3137L63.6877 67.2034L63.8016 67.135C64.2155 66.8841 64.4661 66.4279 64.5648 65.9603C64.6711 65.4889 64.6142 64.9985 64.5079 64.5348C64.2687 63.6072 63.9345 62.7176 63.6725 61.8737C63.1296 60.1896 62.6398 58.6804 62.2297 57.4107C61.8387 56.1676 61.5197 55.1602 61.2881 54.4341C61.1894 54.1034 61.1097 53.8334 61.0451 53.6282C60.992 53.4419 60.9692 53.3468 60.9768 53.343L60.9882 53.3354Z",
    fill: "#375A64"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8447 114.509C41.8447 114.509 41.7802 114.661 41.6207 114.912C41.4613 115.163 41.2259 115.517 40.9259 115.95C40.326 116.817 39.4641 117.995 38.4693 119.261C37.4745 120.527 36.5329 121.645 35.8305 122.432C35.4812 122.827 35.1926 123.143 34.9876 123.356C34.7826 123.569 34.6649 123.679 34.6497 123.667C34.6231 123.645 35.0294 123.131 35.6938 122.314C36.3583 121.497 37.2733 120.364 38.2681 119.102C39.2591 117.836 40.1437 116.68 40.7816 115.84C41.4195 115 41.8182 114.483 41.8485 114.506L41.8447 114.509Z",
    fill: "#375A64"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5524 108.153C49.5524 108.153 49.5524 108.248 49.5334 108.431C49.5144 108.625 49.484 108.891 49.4461 109.24C49.3625 109.963 49.2448 111.012 49.0929 112.354C48.774 115.057 48.2956 118.969 47.6653 123.797C46.4199 133.452 44.5291 146.769 42.5016 161.481C41.4916 168.841 40.5614 175.855 39.7678 182.245C39.5628 183.842 39.3995 185.4 39.1755 186.913C38.9439 188.419 38.7199 189.882 38.5035 191.296C38.0744 194.125 37.6757 196.763 37.3112 199.169C36.5898 203.982 36.0165 207.879 35.6444 210.578C35.4584 211.927 35.3179 212.973 35.2381 213.684C35.1964 214.041 35.1698 214.311 35.1584 214.493C35.1546 214.585 35.1508 214.653 35.1584 214.699C35.166 214.756 35.1926 214.695 35.1888 214.706C35.1888 214.706 35.1888 214.714 35.1812 214.722C35.1736 214.744 35.1432 214.725 35.1432 214.699C35.1318 214.653 35.1318 214.581 35.1318 214.49C35.1318 214.307 35.1546 214.033 35.1888 213.676C35.2533 212.961 35.3748 211.912 35.5495 210.563C35.895 207.864 36.438 203.959 37.1366 199.143C37.4897 196.733 37.8808 194.098 38.2984 191.266C38.5111 189.852 38.7313 188.388 38.9591 186.879C39.1793 185.374 39.3388 183.811 39.54 182.215C40.3184 175.824 41.241 168.807 42.2548 161.447C44.2861 146.731 46.2035 133.422 47.4945 123.77C48.1285 118.95 48.6449 115.049 49.0018 112.339C49.1765 110.997 49.3094 109.951 49.4043 109.229C49.4536 108.879 49.4878 108.613 49.5144 108.423C49.541 108.241 49.56 108.149 49.56 108.149L49.5524 108.153Z",
    fill: "#375A64"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7719 212.783C60.7719 212.783 60.7795 212.692 60.8061 212.513C60.8364 212.327 60.8782 212.064 60.9352 211.73C61.0529 211.03 61.2275 210.019 61.4477 208.719C61.9072 206.096 62.5678 202.317 63.3841 197.653C65.0472 188.305 67.3367 175.41 69.8692 161.166C70.0552 160.288 70.1198 159.398 70.0249 158.524C69.9148 157.649 69.7667 156.764 69.6376 155.897C69.368 154.156 69.1022 152.441 68.844 150.753C68.3125 147.381 67.7923 144.135 67.2759 141.04C66.2508 134.855 65.256 129.298 64.3713 124.641C63.4829 119.984 62.7045 116.224 62.1122 113.643C61.8312 112.347 61.5806 111.351 61.4212 110.67C61.3452 110.339 61.2845 110.081 61.2427 109.895C61.2047 109.72 61.1895 109.628 61.1895 109.628C61.1895 109.628 61.2199 109.716 61.2655 109.887C61.3148 110.069 61.3832 110.324 61.4705 110.655C61.6452 111.331 61.9147 112.324 62.2071 113.62C62.8298 116.197 63.6347 119.953 64.546 124.606C65.4534 129.263 66.4634 134.817 67.5038 141.002C68.0277 144.093 68.5555 147.343 69.087 150.715C69.349 152.403 69.6148 154.118 69.8844 155.859C70.0135 156.733 70.1578 157.6 70.2717 158.497C70.3666 159.398 70.2983 160.326 70.1122 161.219C67.5531 175.456 65.2332 188.347 63.5512 197.687C62.7007 202.344 62.0135 206.119 61.5351 208.734C61.2921 210.031 61.1022 211.038 60.9731 211.737C60.9086 212.072 60.8554 212.331 60.8212 212.517C60.7871 212.692 60.7605 212.779 60.7605 212.779L60.7719 212.783Z",
    fill: "#375A64"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2399 123.671C55.3082 123.683 54.4387 129.541 53.2997 136.76C52.1568 143.979 51.1734 149.818 51.1051 149.811C51.0367 149.799 51.9062 143.941 53.0491 136.722C54.1919 129.507 55.1753 123.664 55.2437 123.675L55.2399 123.671Z",
    fill: "#375A64"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7281 52.3013C43.7281 52.3013 43.9331 52.4115 44.271 52.651C44.6545 52.9171 45.1405 53.2555 45.7176 53.6546C46.944 54.4948 48.6602 55.6201 50.627 56.7454C51.3636 57.1673 52.085 57.5627 52.7494 57.9162L52.5748 57.9961C52.9886 56.3652 53.3493 54.9624 53.6189 53.9664C53.748 53.5064 53.8543 53.1224 53.9417 52.8069C54.0214 52.537 54.0707 52.3925 54.0859 52.3963C54.1011 52.3963 54.0783 52.5522 54.0214 52.8259C53.953 53.1452 53.8657 53.5368 53.767 54.0044C53.5392 55.008 53.2088 56.4184 52.8102 58.0531L52.7722 58.2052L52.6317 58.1329C51.9597 57.7832 51.2345 57.3916 50.4941 56.9696C48.5197 55.8406 46.8111 54.6849 45.6075 53.8029C45.0038 53.3657 44.5292 52.9932 44.2065 52.7308C43.8837 52.4647 43.7129 52.3127 43.7205 52.3013H43.7281Z",
    fill: "#375A64"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9783 55.9243C60.0049 55.9699 59.105 56.5781 57.8065 57.3955L57.6964 57.4639L57.6356 57.3461C57.4268 56.9393 57.2028 56.5059 56.9712 56.0535C56.4624 55.0499 56.0143 54.1337 55.703 53.4646C55.3917 52.7955 55.2132 52.3735 55.2436 52.3583C55.274 52.3431 55.5094 52.7347 55.8625 53.381C56.2156 54.0272 56.6902 54.932 57.199 55.9357C57.4268 56.3919 57.6432 56.829 57.8482 57.2358L57.6812 57.1864C58.9987 56.3995 59.9517 55.8748 59.9783 55.9204V55.9243Z",
    fill: "#375A64"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7586 55.445C56.7586 55.445 56.603 55.5857 56.3258 55.7834C56.0524 55.9811 55.6689 56.251 55.2399 56.5437C54.8146 56.8364 54.4235 57.0949 54.1388 57.2812C53.854 57.4637 53.6756 57.5739 53.668 57.5625C53.6604 57.5511 53.8274 57.4219 54.1008 57.2204C54.3742 57.0227 54.7577 56.7528 55.1829 56.4601C55.6082 56.1673 55.9992 55.9088 56.284 55.7226C56.5688 55.5401 56.751 55.4298 56.7586 55.4412V55.445Z",
    fill: "#375A64"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2816 56.464C55.2626 56.483 54.8336 56.08 54.3248 55.5592C53.816 55.0384 53.4211 54.6012 53.4401 54.5822C53.4591 54.5632 53.8881 54.9699 54.3969 55.487C54.9019 56.0078 55.3006 56.445 55.2816 56.464Z",
    fill: "#375A64"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4899 90.8677C58.4899 90.8677 58.5696 91.0501 58.6722 91.3961C58.7747 91.742 58.9076 92.2439 59.0556 92.8673C59.3594 94.1143 59.7163 95.8516 60.0049 97.7866C60.2896 99.7254 60.4529 101.493 60.525 102.771C60.563 103.409 60.582 103.93 60.582 104.287C60.582 104.645 60.582 104.846 60.563 104.846C60.544 104.846 60.5174 104.649 60.4833 104.295C60.4453 103.884 60.3997 103.379 60.3428 102.786C60.2251 101.512 60.0352 99.7558 59.7505 97.8246C59.4657 95.8934 59.1354 94.1599 58.8772 92.9053C58.7557 92.3199 58.657 91.8257 58.5734 91.4189C58.5013 91.0692 58.4709 90.8715 58.4899 90.8677Z",
    fill: "#375A64"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.958 101.972L63.6006 95.4905L56.9864 59.1821L55.0576 59.376C55.0576 59.376 55.3272 97.11 55.2399 97.4521L60.958 101.972Z",
    fill: "#09363F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9103 59.1859C56.9141 59.2125 56.5079 59.2999 55.9953 59.3341C55.4827 59.3721 55.0688 59.3455 55.0688 59.3189C55.0688 59.2885 55.4827 59.2695 55.9877 59.2315C56.4965 59.1935 56.9065 59.1554 56.9103 59.1859Z",
    fill: "#1A2E35"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M109.329 83.3031C109.329 83.3031 109.447 81.292 108.206 81.1096C106.949 80.9271 102.81 80.5926 103.805 83.2955C103.805 83.2955 100.692 82.8963 100.395 83.9646C100.099 85.0328 100.692 85.2761 100.692 85.2761C100.692 85.2761 99.7233 86.0859 100.692 86.7968C101.641 87.4925 102.734 87.6293 102.734 87.6293C102.734 87.6293 101.88 88.4353 102.639 88.8725C103.266 89.2336 107.078 90.8873 108.206 87.0933L109.329 83.2993V83.3031Z",
    fill: "#CCEDE8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M100.35 85.1997C100.339 85.2681 101.618 85.5609 103.213 85.8574C104.807 86.1539 106.106 86.3364 106.121 86.268C106.133 86.1995 104.853 85.9068 103.258 85.6103C101.664 85.3176 100.365 85.1313 100.35 85.1997Z",
    fill: "#95C9C3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.222 83.5006C107.226 83.4322 106.391 83.3219 105.35 83.2535C104.314 83.1851 103.467 83.1889 103.463 83.2535C103.46 83.3219 104.295 83.4322 105.335 83.5006C106.372 83.5691 107.218 83.5652 107.222 83.5006Z",
    fill: "#95C9C3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.252 88.5072C105.271 88.4388 104.564 88.2069 103.699 87.9104C102.833 87.6176 102.131 87.3705 102.104 87.4352C102.077 87.496 102.742 87.8495 103.619 88.1461C104.496 88.4464 105.236 88.5719 105.252 88.5072Z",
    fill: "#95C9C3"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M145.934 106.298H68.5706V179.816H145.934V106.298Z",
    fill: "#DAF2EF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4188 160.151H0V153.308H23.4188C25.8449 153.308 27.8155 151.331 27.8155 148.906C27.8155 142.706 32.8538 137.661 39.0464 137.661H68.5667V144.504H39.0464C36.6203 144.504 34.6497 146.481 34.6497 148.906C34.6497 155.106 29.6114 160.151 23.4188 160.151Z",
    fill: "url(#paint0_linear_35_124377)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.842 106.298H145.934V179.816H159.842V106.298Z",
    fill: "#09363F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M190.486 154.175H152.89V147.332H190.486C192.912 147.332 194.883 145.355 194.883 142.93V133.852C194.883 127.652 199.921 122.607 206.114 122.607H242.996V129.45H206.114C203.688 129.45 201.717 131.426 201.717 133.852V142.93C201.717 149.13 196.679 154.175 190.486 154.175Z",
    fill: "url(#paint1_linear_35_124377)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.197 127.762L103.843 129.294L103.699 129.377L97.2783 133.091V146.75L95.6304 145.796C95.0153 145.439 94.6318 144.777 94.6318 144.066V132.715C94.6318 132 95.0153 131.339 95.6304 130.985L101.197 127.766V127.762Z",
    fill: "#30CFB0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M106.44 130.792L107.761 131.559V145.219L106.44 145.983L105.115 145.219V131.559L105.16 131.529L106.44 130.792Z",
    fill: "#30CFB0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.522 133.058V146.716L109.086 150.514L107.439 151.468C107.139 151.639 106.789 151.734 106.44 151.734C106.091 151.734 105.741 151.639 105.441 151.468L99.8752 148.245V134.586L102.525 133.054L102.522 133.058Z",
    fill: "#30CFB0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M106.436 125.04C106.782 125.04 107.127 125.127 107.435 125.306L113.001 128.53V142.185L110.355 143.717V130.062L103.79 126.264L105.438 125.31C105.745 125.135 106.091 125.044 106.436 125.044V125.04Z",
    fill: "#30CFB0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M115.594 130.028L117.242 130.982C117.861 131.335 118.241 131.997 118.241 132.712V144.063C118.241 144.774 117.861 145.435 117.246 145.793L111.68 149.013L109.029 147.481L109.17 147.397L115.59 143.683V130.024L115.594 130.028Z",
    fill: "#30CFB0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123.902 89.7544H90.0757V106.299H123.902V89.7544Z",
    fill: "url(#paint2_linear_35_124377)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M243 159.011H188.88C185.178 159.011 182.167 155.996 182.167 152.29V147.488C182.167 144.618 179.836 142.288 176.973 142.288H152.894V140.767H176.973C180.675 140.767 183.686 143.782 183.686 147.488V152.29C183.686 155.16 186.017 157.49 188.88 157.49H243V159.011Z",
    fill: "url(#paint3_linear_35_124377)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3803 165.853H0.00390625V164.333H34.3803C36.2559 164.333 37.7784 162.804 37.7784 160.93V157.163C37.7784 154.448 39.9844 152.24 42.6953 152.24H68.5706V153.76H42.6953C40.8197 153.76 39.2971 155.289 39.2971 157.163V160.93C39.2971 163.645 37.0912 165.853 34.3803 165.853Z",
    fill: "url(#paint4_linear_35_124377)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M207.207 136.669H152.89V135.148H207.207C209.964 135.148 212.208 132.901 212.208 130.141V123.048C212.208 119.448 215.131 116.521 218.727 116.521H243V118.041H218.727C215.97 118.041 213.727 120.288 213.727 123.048V130.141C213.727 133.741 210.803 136.669 207.207 136.669Z",
    fill: "url(#paint5_linear_35_124377)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1665 142.41H0.00390625V140.889H48.1665C50.5015 140.889 52.4 138.988 52.4 136.65V133.126C52.4 129.952 54.9818 127.367 58.1521 127.367H68.5744V128.887H58.1521C55.8171 128.887 53.9187 130.788 53.9187 133.126V136.65C53.9187 139.825 51.3368 142.41 48.1665 142.41Z",
    fill: "url(#paint6_linear_35_124377)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 4.68164H237.305C240.173 4.68164 242.5 7.01026 242.5 9.88406V174.114C242.5 176.988 240.173 179.316 237.305 179.316H5.69531C2.82661 179.316 0.5 176.988 0.5 174.114V9.88406C0.5 7.01026 2.82661 4.68164 5.69531 4.68164Z",
    stroke: "#849A9F",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4184 46.3638L85.5233 43.0375C84.4146 41.3724 83.735 39.3918 83.6552 37.2478C83.4274 31.0779 88.2419 25.8926 94.4042 25.6645C100.567 25.4364 105.745 30.2568 105.973 36.4266C106.201 42.5965 101.387 47.7818 95.2243 48.0099C92.65 48.1049 90.2504 47.318 88.3102 45.9229H88.314L84.4184 46.3676V46.3638Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4184 46.3636C84.4184 46.3636 84.5095 46.3484 84.6766 46.3294C84.8513 46.3066 85.0981 46.2762 85.4246 46.2382C86.0815 46.1583 87.0497 46.0405 88.3064 45.8922L88.2836 45.9492H88.2799C88.2685 45.9302 88.2685 45.9074 88.2836 45.896C88.295 45.8846 88.314 45.8846 88.3254 45.896C89.5138 46.74 91.2452 47.6219 93.455 47.8842C94.0055 47.9489 94.5789 47.9793 95.175 47.9565C95.7673 47.907 96.3824 47.8728 97.0013 47.7284C98.2429 47.4775 99.5186 46.9947 100.707 46.242C101.899 45.4893 103 44.4705 103.881 43.2121C104.758 41.9576 105.411 40.4674 105.711 38.8556C106.338 35.6395 105.392 31.9178 102.921 29.2871C101.664 27.9566 100.122 26.9188 98.4479 26.3638C96.7811 25.7859 95.0269 25.6263 93.3715 25.8354C91.7122 26.0368 90.1669 26.6451 88.8532 27.4814C87.5395 28.3216 86.4573 29.4012 85.6524 30.5797C84.8437 31.7581 84.3083 33.0355 84.0122 34.2786C83.978 34.4344 83.9438 34.5903 83.9096 34.7461C83.8717 34.8982 83.8413 35.0541 83.8299 35.2061C83.7957 35.5141 83.7578 35.8182 83.7236 36.1147C83.7198 36.7153 83.6856 37.2932 83.7426 37.8482C83.94 40.0759 84.7601 41.8322 85.5461 43.0221C85.5537 43.0297 85.5537 43.0411 85.5499 43.0525C85.1854 44.1245 84.9044 44.9494 84.7146 45.5121C84.6197 45.7896 84.5475 46.0025 84.4944 46.1507C84.445 46.2952 84.4146 46.3712 84.4146 46.3712C84.4146 46.3712 84.4336 46.3028 84.4792 46.1621C84.5247 46.0139 84.5931 45.8048 84.6804 45.5273C84.8665 44.9571 85.136 44.1207 85.4853 43.0335V43.0639C84.688 41.874 83.8489 40.1139 83.6401 37.8634C83.5755 37.3046 83.6097 36.7191 83.6135 36.1109C83.6477 35.8106 83.6818 35.5026 83.716 35.1909C83.7274 35.0351 83.7578 34.8792 83.7957 34.7233C83.8299 34.5675 83.8641 34.4116 83.8983 34.2519C84.1944 32.9936 84.7298 31.7011 85.5461 30.5036C86.3586 29.31 87.4521 28.2113 88.781 27.3598C90.1099 26.512 91.6743 25.8924 93.3563 25.6833C95.0345 25.4704 96.8152 25.6301 98.5048 26.2155C100.202 26.7781 101.766 27.8274 103.042 29.1807C103.209 29.3366 103.346 29.519 103.486 29.6939L103.912 30.2223L104.284 30.7849C104.409 30.9712 104.534 31.1575 104.629 31.359C104.732 31.5567 104.838 31.7543 104.941 31.952C105.051 32.1459 105.115 32.3588 105.206 32.5641C105.286 32.7693 105.381 32.9708 105.449 33.1799C105.51 33.3928 105.575 33.6019 105.635 33.811C106.11 35.495 106.178 37.2514 105.867 38.8822C105.563 40.5169 104.899 42.0261 104.007 43.2958C103.114 44.5655 101.994 45.5995 100.787 46.356C99.5794 47.1163 98.2846 47.5991 97.0316 47.8462C96.4052 47.9907 95.7825 48.0211 95.1864 48.0705C94.5865 48.0895 94.0055 48.0591 93.4512 47.9907C91.2186 47.7132 89.4797 46.8122 88.2912 45.9531L88.3368 45.9036H88.3406C88.352 45.9226 88.352 45.9454 88.3368 45.9569C88.333 45.9607 88.3254 45.9645 88.3178 45.9645C87.0459 46.0975 86.0701 46.2002 85.4056 46.2724C85.0829 46.3066 84.8361 46.3294 84.6652 46.3484C84.502 46.3636 84.4222 46.3712 84.4222 46.3712L84.4184 46.3636Z",
    fill: "#E1E1E1",
    stroke: "#E1E1E1",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6543 37.1338L91.2148 35.4079L94.5257 38.0652L99.4388 32.416L101.045 33.9823L94.4498 41.251L89.6543 37.1338Z",
    fill: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_124377",
    x1: 0.00379682,
    y1: 148.906,
    x2: 68.5743,
    y2: 148.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_124377",
    x1: 242.996,
    y1: 138.387,
    x2: 152.886,
    y2: 138.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_124377",
    x1: 106.987,
    y1: 89.5605,
    x2: 106.987,
    y2: 105.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6FDFB",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#DDF7F2",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B2EDE1",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#78DFCB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_124377",
    x1: 242.996,
    y1: 149.887,
    x2: 152.886,
    y2: 149.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_124377",
    x1: 0.00390625,
    y1: 159.048,
    x2: 68.5706,
    y2: 159.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_124377",
    x1: 152.89,
    y1: 126.595,
    x2: 243,
    y2: 126.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30CFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_124377",
    x1: 0.00390625,
    y1: 134.89,
    x2: 68.5706,
    y2: 134.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingImg);
export default __webpack_public_path__ + "static/media/votingImg.6837cb1437f16c856e0a9fb4feaae34b.svg";
export { ForwardRef as ReactComponent };